/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never};
import type * as Types from './schema';

import {gql} from '@apollo/client';
import * as Apollo from '@apollo/client';
export * from './schema';
const defaultOptions = {} as const;
export type AddressFragmentFragment = {
  id: string | null;
  orderId: string | null;
  userId: string | null;
  industryTypeId: string | null;
  firstName: string | null;
  lastName: string | null;
  gender: string | null;
  genderText: string | null;
  birthdayYear: string | null;
  birthdayMonth: string | null;
  birthdayDay: string | null;
  tel: string | null;
  zipcode: string | null;
  address1: string | null;
  address2: string | null;
  companyName: string | null;
  companyNameKana: string | null;
  companyBranchName: string | null;
  companyPosition: string | null;
  companyTel: string | null;
  companyFax: string | null;
};

export type AdminDoorKeyFragmentFragment = {
  id: string;
  keyNumber: string;
  target: string;
  targetName: string;
  reservationNumber: string;
  eventId: string | null;
  url: string;
  guestName: string;
  guestEmail: string;
  spaceName: string;
  status: string;
  issuedAt: any;
  mailSentAt: any;
  lastUnlockedAt: any;
  revokedAt: any;
  revokedByName: string | null;
  reissuable: boolean;
  windows: Array<{unlockText: string; useText: string}>;
  activities: Array<{
    id: string;
    createdAt: any;
    actionName: string;
    actorName: string;
    succeeded: boolean;
    detail: string | null;
  }>;
};

export type BankFragmentFragment = {
  id: string | null;
  userId: string | null;
  name: string | null;
  branch: string | null;
  accountType: string | null;
  accountTypeText: string | null;
  accountNumber: string | null;
  accountName: string | null;
};

export type ContactFragmentFragment = {
  id: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  tel: string | null;
  message: string | null;
};

export type PublicDoorKeyFragmentFragment = {
  state: string;
  guestName: string | null;
  spaceName: string | null;
  windows: Array<{unlockText: string; useText: string}>;
};

export type EventFragmentFragment = {
  id: string | null;
  groupId: string | null;
  title: string | null;
  description: string | null;
  eventDate: any;
  eventDatetimeText: string | null;
  eventDateText: string | null;
  eventDateWday: string | null;
  startTimeText: string | null;
  mainImage: string | null;
  mainImageUrl: string | null;
  eventStatus: string | null;
  eventStatusText: string | null;
  paymentStatus: string | null;
  paymentStatusText: string | null;
  akerunStatus: string | null;
  akerunStatusText: string | null;
  locationType: string | null;
  locationTypeText: string | null;
  location: string | null;
  ticketQuantity: number | null;
  ticketAmount: number | null;
  isFree: boolean | null;
  dueDate: any;
  dueDateText: string | null;
  dueTime: string | null;
  dueTimeText: string | null;
  address: string | null;
  organizer: string | null;
  informationEmail: string | null;
  informationTel: string | null;
  acmPrice: number | null;
  taxAcmPrice: number | null;
  guestCount: number | null;
  cancelDate: string | null;
  cancelDateText: string | null;
  cancelTime: string | null;
  cancelTimeText: string | null;
  canCancel: boolean | null;
  onShowpage: boolean | null;
  isShowEventList: boolean | null;
  eventType: string | null;
  eventTypeText: string | null;
  chargeId: string | null;
  ticketPaymentMethod: string | null;
  ticketPaymentMethodText: string | null;
  ownerPaymentStatus: string | null;
  ownerPaymentStatusText: string | null;
  isReceipt: boolean | null;
  receiptName: string | null;
  ownerPaymentDate: string | null;
  receiptStatus: string | null;
  receiptStatusText: string | null;
  orderCount: number | null;
  totalSalesPrice: number | null;
  totalFee: number | null;
  totalPaymentPrice: number | null;
};

export type EventOptionFragmentFragment = {
  id: string | null;
  eventId: string | null;
  optionId: string | null;
  isApply: boolean | null;
};

export type EventScheduleFragmentFragment = {
  id: string | null;
  eventId: string | null;
  eventDate: any;
  eventDateText: string | null;
  eventDateTextFull: string | null;
  eventDateWday: string | null;
  startTime: string | null;
  startTimeText: string | null;
  endTime: string | null;
  endTimeText: string | null;
};

export type GroupFragmentFragment = {
  id: string | null;
  name: string | null;
  mainImage: string | null;
  mainImageUrl: string | null;
  content: string | null;
  location: string | null;
  owner: string | null;
  isAdmin: boolean | null;
  groupAdminCount: number | null;
  groupMemberCount: number | null;
  groupFollowerCount: number | null;
};

export type GroupActivityFragmentFragment = {
  id: string | null;
  groupId: string | null;
  userId: string | null;
  title: string | null;
};

export type GroupCommentFragmentFragment = {
  id: string | null;
  groupActivityId: string | null;
  userId: string | null;
  message: string | null;
  createdAtText: string | null;
  isEdit: boolean | null;
  isRemove: boolean | null;
};

export type IndustryTypeFragmentFragment = {
  id: string | null;
  name: string | null;
};

export type NotificationFragmentFragment = {
  id: string | null;
  status: string | null;
  statusText: string | null;
  message: string | null;
  startDate: any;
  endDate: any;
  startDateText: any;
  endDateText: any;
};

export type OptionFragmentFragment = {
  id: string | null;
  optionType: string | null;
  name: string | null;
  description: string | null;
};

export type OrderFragmentFragment = {
  id: string | null;
  workflowState: string | null;
  workflowStateText: string | null;
  totalPrice: number | null;
  completedAtText: string | null;
  chargeId: string | null;
  paymentState: string | null;
  paymentStateText: string | null;
};

export type PaginationFragmentFragment = {
  resultsCount: number | null;
  totalCount: number | null;
  totalPages: number | null;
  currentPage: number | null;
  nextPage: number | null;
  previousPage: number | null;
  hasNextPage: boolean | null;
  hasPreviousPage: boolean | null;
};

export type PayjpCardFragmentFragment = {
  id: string | null;
  cardId: string | null;
  customerId: string | null;
  created: number | null;
  name: string | null;
  last4: string | null;
  expMonth: string | null;
  expYear: string | null;
};

export type PayjpCustomerFragmentFragment = {
  id: string | null;
  userId: string | null;
  customerId: string | null;
};

export type PaymentFragmentFragment = {
  id: string | null;
  eventId: string | null;
  paymentMethod: string | null;
};

export type RoomCalendarFragmentFragment = {
  id: string | null;
  roomId: string | null;
  eventId: string | null;
  targetDate: any;
  startTime: string | null;
  startTimeText: string | null;
  endTime: string | null;
  endTimeText: string | null;
  targetDateText: string | null;
  calendarType: string | null;
  memo: string | null;
};

export type UserFragmentFragment = {
  id: string | null;
  email: string | null;
  avatar: string | null;
  fullName: string | null;
  createdAtText: string | null;
  updatedAtText: string | null;
  deactivatedAtText: string | null;
};

export type ChangePasswordMutationVariables = Exact<{
  password: Types.PasswordAttributes;
}>;

export type ChangePasswordMutation = {
  changePassword: {
    error: string | null;
    user: {
      id: string | null;
      email: string | null;
      avatar: string | null;
      fullName: string | null;
      createdAtText: string | null;
      updatedAtText: string | null;
      deactivatedAtText: string | null;
    } | null;
  };
};

export type ConfirmMutationVariables = Exact<{
  token: string;
}>;

export type ConfirmMutation = {
  confirm: {
    error: string | null;
    user: {
      id: string | null;
      email: string | null;
      avatar: string | null;
      fullName: string | null;
      createdAtText: string | null;
      updatedAtText: string | null;
      deactivatedAtText: string | null;
    } | null;
  } | null;
};

export type RequestPasswordResetMutationVariables = Exact<{
  email: string;
}>;

export type RequestPasswordResetMutation = {
  requestPasswordReset: {error: string | null} | null;
};

export type ResetPasswordMutationVariables = Exact<{
  input: Types.ResetPasswordInput;
}>;

export type ResetPasswordMutation = {
  resetPassword: {error: string | null} | null;
};

export type SigninMutationVariables = Exact<{
  email: string;
  password: string;
}>;

export type SigninMutation = {
  signin: {
    otpRequired: boolean | null;
    error: string | null;
    user: {
      id: string | null;
      email: string | null;
      avatar: string | null;
      fullName: string | null;
      createdAtText: string | null;
      updatedAtText: string | null;
      deactivatedAtText: string | null;
    } | null;
  };
};

export type SignoutMutationVariables = Exact<{[key: string]: never}>;

export type SignoutMutation = {signout: {result: string | null}};

export type SignupMutationVariables = Exact<{
  user: Types.UserInputType;
  password: Types.PasswordAttributes;
}>;

export type SignupMutation = {
  signup: {error: string | null; user: {id: string | null} | null};
};

export type VerifyOtpMutationVariables = Exact<{
  code: string;
}>;

export type VerifyOtpMutation = {
  verifyOtp: {
    remainingAttempts: number | null;
    error: string | null;
    user: {
      id: string | null;
      email: string | null;
      avatar: string | null;
      fullName: string | null;
      createdAtText: string | null;
      updatedAtText: string | null;
      deactivatedAtText: string | null;
    } | null;
  };
};

export type UpdateBankMutationVariables = Exact<{
  bank: Types.BankInputType;
}>;

export type UpdateBankMutation = {
  updateBank: {
    bank: {
      id: string | null;
      userId: string | null;
      name: string | null;
      branch: string | null;
      accountType: string | null;
      accountTypeText: string | null;
      accountNumber: string | null;
      accountName: string | null;
    } | null;
  } | null;
};

export type AddressMutationVariables = Exact<{
  id: string | number;
  address: Types.AddressInputType;
}>;

export type AddressMutation = {
  address: {
    error: string | null;
    order: {
      id: string | null;
      user: {
        id: string | null;
        email: string | null;
        avatar: string | null;
        fullName: string | null;
        createdAtText: string | null;
        updatedAtText: string | null;
        deactivatedAtText: string | null;
        address: {
          id: string | null;
          orderId: string | null;
          userId: string | null;
          industryTypeId: string | null;
          firstName: string | null;
          lastName: string | null;
          gender: string | null;
          genderText: string | null;
          birthdayYear: string | null;
          birthdayMonth: string | null;
          birthdayDay: string | null;
          tel: string | null;
          zipcode: string | null;
          address1: string | null;
          address2: string | null;
          companyName: string | null;
          companyNameKana: string | null;
          companyBranchName: string | null;
          companyPosition: string | null;
          companyTel: string | null;
          companyFax: string | null;
          industryType: {id: string | null} | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CreatePayjpCustomerMutationVariables = Exact<{
  attributes: Types.PayjpCustomerAttributes;
}>;

export type CreatePayjpCustomerMutation = {
  createPayjpCustomer: {
    payjpCustomer: {
      id: string | null;
      userId: string | null;
      customerId: string | null;
      card: {
        id: string | null;
        cardId: string | null;
        customerId: string | null;
        created: number | null;
        name: string | null;
        last4: string | null;
        expMonth: string | null;
        expYear: string | null;
      } | null;
    } | null;
  } | null;
};

export type OrderMutationVariables = Exact<{
  id: string | number;
}>;

export type OrderMutation = {
  order: {
    error: string | null;
    tdsRequired: boolean | null;
    order: {
      id: string | null;
      workflowState: string | null;
      workflowStateText: string | null;
      totalPrice: number | null;
      completedAtText: string | null;
      chargeId: string | null;
      paymentState: string | null;
      paymentStateText: string | null;
    } | null;
  } | null;
};

export type PaymentMutationVariables = Exact<{
  id: string | number;
}>;

export type PaymentMutation = {
  payment: {
    error: string | null;
    order: {
      id: string | null;
      workflowState: string | null;
      workflowStateText: string | null;
      totalPrice: number | null;
      completedAtText: string | null;
      chargeId: string | null;
      paymentState: string | null;
      paymentStateText: string | null;
    } | null;
  } | null;
};

export type TdsFinishOrderMutationVariables = Exact<{
  orderId: string | number;
}>;

export type TdsFinishOrderMutation = {
  tdsFinishOrder: {
    error: string | null;
    order: {
      id: string | null;
      workflowState: string | null;
      workflowStateText: string | null;
      totalPrice: number | null;
      completedAtText: string | null;
      chargeId: string | null;
      paymentState: string | null;
      paymentStateText: string | null;
    } | null;
  } | null;
};

export type UpdatePayjpCustomerMutationVariables = Exact<{
  id: string | number;
  attributes: Types.PayjpCustomerAttributes;
}>;

export type UpdatePayjpCustomerMutation = {
  updatePayjpCustomer: {
    payjpCustomer: {
      id: string | null;
      userId: string | null;
      customerId: string | null;
      card: {
        id: string | null;
        cardId: string | null;
        customerId: string | null;
        created: number | null;
        name: string | null;
        last4: string | null;
        expMonth: string | null;
        expYear: string | null;
      } | null;
    } | null;
  } | null;
};

export type CreateContactMutationVariables = Exact<{
  attributes: Types.ContactAttributes;
}>;

export type CreateContactMutation = {
  createContact: {
    error: string | null;
    contact: {
      id: string | null;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      tel: string | null;
      message: string | null;
    } | null;
  } | null;
};

export type RefreshDoorLockMutationVariables = Exact<{
  target: string;
}>;

export type RefreshDoorLockMutation = {
  refreshDoorLock: {
    error: string | null;
    doorLock: {
      target: string;
      targetName: string;
      batteryPercentage: number | null;
      lockStatus: string | null;
      fetchedAt: any;
      lowBattery: boolean;
      lowBatteryThreshold: number;
    } | null;
  } | null;
};

export type ReissueDoorKeyMutationVariables = Exact<{
  input: Types.ReissueDoorKeyInput;
}>;

export type ReissueDoorKeyMutation = {
  reissueDoorKey: {
    message: string | null;
    error: string | null;
    doorKey: {
      id: string;
      keyNumber: string;
      target: string;
      targetName: string;
      reservationNumber: string;
      eventId: string | null;
      url: string;
      guestName: string;
      guestEmail: string;
      spaceName: string;
      status: string;
      issuedAt: any;
      mailSentAt: any;
      lastUnlockedAt: any;
      revokedAt: any;
      revokedByName: string | null;
      reissuable: boolean;
      windows: Array<{unlockText: string; useText: string}>;
      activities: Array<{
        id: string;
        createdAt: any;
        actionName: string;
        actorName: string;
        succeeded: boolean;
        detail: string | null;
      }>;
    } | null;
  } | null;
};

export type RemoteUnlockDoorMutationVariables = Exact<{
  input: Types.RemoteUnlockDoorInput;
}>;

export type RemoteUnlockDoorMutation = {
  remoteUnlockDoor: {
    message: string | null;
    error: string | null;
    doorKey: {
      id: string;
      keyNumber: string;
      target: string;
      targetName: string;
      reservationNumber: string;
      eventId: string | null;
      url: string;
      guestName: string;
      guestEmail: string;
      spaceName: string;
      status: string;
      issuedAt: any;
      mailSentAt: any;
      lastUnlockedAt: any;
      revokedAt: any;
      revokedByName: string | null;
      reissuable: boolean;
      windows: Array<{unlockText: string; useText: string}>;
      activities: Array<{
        id: string;
        createdAt: any;
        actionName: string;
        actorName: string;
        succeeded: boolean;
        detail: string | null;
      }>;
    } | null;
  } | null;
};

export type ResendDoorKeyMailMutationVariables = Exact<{
  input: Types.ResendDoorKeyMailInput;
}>;

export type ResendDoorKeyMailMutation = {
  resendDoorKeyMail: {
    message: string | null;
    error: string | null;
    doorKey: {
      id: string;
      keyNumber: string;
      target: string;
      targetName: string;
      reservationNumber: string;
      eventId: string | null;
      url: string;
      guestName: string;
      guestEmail: string;
      spaceName: string;
      status: string;
      issuedAt: any;
      mailSentAt: any;
      lastUnlockedAt: any;
      revokedAt: any;
      revokedByName: string | null;
      reissuable: boolean;
      windows: Array<{unlockText: string; useText: string}>;
      activities: Array<{
        id: string;
        createdAt: any;
        actionName: string;
        actorName: string;
        succeeded: boolean;
        detail: string | null;
      }>;
    } | null;
  } | null;
};

export type RevokeDoorKeyMutationVariables = Exact<{
  input: Types.RevokeDoorKeyInput;
}>;

export type RevokeDoorKeyMutation = {
  revokeDoorKey: {
    message: string | null;
    error: string | null;
    doorKey: {
      id: string;
      keyNumber: string;
      target: string;
      targetName: string;
      reservationNumber: string;
      eventId: string | null;
      url: string;
      guestName: string;
      guestEmail: string;
      spaceName: string;
      status: string;
      issuedAt: any;
      mailSentAt: any;
      lastUnlockedAt: any;
      revokedAt: any;
      revokedByName: string | null;
      reissuable: boolean;
      windows: Array<{unlockText: string; useText: string}>;
      activities: Array<{
        id: string;
        createdAt: any;
        actionName: string;
        actorName: string;
        succeeded: boolean;
        detail: string | null;
      }>;
    } | null;
  } | null;
};

export type UnlockDoorKeyMutationVariables = Exact<{
  token: string;
}>;

export type UnlockDoorKeyMutation = {
  unlockDoorKey: {
    result: string;
    message: string;
    doorKey: {
      state: string;
      guestName: string | null;
      spaceName: string | null;
      windows: Array<{unlockText: string; useText: string}>;
    };
  } | null;
};

export type AcceptEventMutationVariables = Exact<{
  id: string | number;
  event: Types.EventInputType;
}>;

export type AcceptEventMutation = {
  acceptEvent: {
    error: string | null;
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
    } | null;
  } | null;
};

export type ApplyCouponToEventMutationVariables = Exact<{
  id: string | number;
  coupon: string;
}>;

export type ApplyCouponToEventMutation = {
  applyCouponToEvent: {
    error: string | null;
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
    } | null;
  } | null;
};

export type ApplyEventMutationVariables = Exact<{
  id: string | number;
  event: Types.EventInputType;
}>;

export type ApplyEventMutation = {
  applyEvent: {
    tdsRequired: boolean | null;
    error: string | null;
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
    } | null;
  } | null;
};

export type CreateEventMutationVariables = Exact<{
  event: Types.EventInputType;
}>;

export type CreateEventMutation = {
  createEvent: {
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
    } | null;
  } | null;
};

export type RejectEventMutationVariables = Exact<{
  id: string | number;
  event: Types.EventInputType;
}>;

export type RejectEventMutation = {
  rejectEvent: {
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
    } | null;
  } | null;
};

export type RemoveEventMutationVariables = Exact<{
  id: string | number;
}>;

export type RemoveEventMutation = {
  removeEvent: {
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
    } | null;
  } | null;
};

export type RevertEventMutationVariables = Exact<{
  id: string | number;
}>;

export type RevertEventMutation = {
  revertEvent: {
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
    } | null;
  } | null;
};

export type TdsFinishEventMutationVariables = Exact<{
  eventId: string | number;
}>;

export type TdsFinishEventMutation = {
  tdsFinishEvent: {
    error: string | null;
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
    } | null;
  } | null;
};

export type UpdateEventMutationVariables = Exact<{
  id: string | number;
  event?: Types.EventInputType | null | undefined;
  file?: any;
}>;

export type UpdateEventMutation = {
  updateEvent: {
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
    } | null;
  } | null;
};

export type UpdateEventOptionMutationVariables = Exact<{
  id: string | number;
  eventOption: Types.EventOptionInputType;
}>;

export type UpdateEventOptionMutation = {
  updateEventOption: {
    eventOption: {
      id: string | null;
      eventId: string | null;
      optionId: string | null;
      isApply: boolean | null;
    } | null;
  } | null;
};

export type CreateEventScheduleMutationVariables = Exact<{
  eventSchedule: Types.EventScheduleInputType;
}>;

export type CreateEventScheduleMutation = {
  createEventSchedule: {
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
      eventSchedules: Array<{
        id: string | null;
        eventId: string | null;
        eventDate: any;
        eventDateText: string | null;
        eventDateTextFull: string | null;
        eventDateWday: string | null;
        startTime: string | null;
        startTimeText: string | null;
        endTime: string | null;
        endTimeText: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type RemoveEventScheduleMutationVariables = Exact<{
  id: string | number;
}>;

export type RemoveEventScheduleMutation = {
  removeEventSchedule: {
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
      eventSchedules: Array<{
        id: string | null;
        eventId: string | null;
        eventDate: any;
        eventDateText: string | null;
        eventDateTextFull: string | null;
        eventDateWday: string | null;
        startTime: string | null;
        startTimeText: string | null;
        endTime: string | null;
        endTimeText: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type UpdateEventScheduleMutationVariables = Exact<{
  id: string | number;
  eventSchedule: Types.EventScheduleInputType;
}>;

export type UpdateEventScheduleMutation = {
  updateEventSchedule: {
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
      eventSchedules: Array<{
        id: string | null;
        eventId: string | null;
        eventDate: any;
        eventDateText: string | null;
        eventDateTextFull: string | null;
        eventDateWday: string | null;
        startTime: string | null;
        startTimeText: string | null;
        endTime: string | null;
        endTimeText: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type AcceptRequestMutationVariables = Exact<{
  id: string | number;
}>;

export type AcceptRequestMutation = {
  acceptRequest: {
    request: {
      id: string | null;
      groupId: string | null;
      userId: string | null;
      status: string | null;
    } | null;
  } | null;
};

export type AddGroupActivityMutationVariables = Exact<{
  attributes: Types.GroupActivityAttributes;
}>;

export type AddGroupActivityMutation = {
  addGroupActivity: {
    group: {
      id: string | null;
      isAdmin: boolean | null;
      name: string | null;
      activities: Array<{
        id: string | null;
        groupId: string | null;
        userId: string | null;
        title: string | null;
        comments: Array<{
          id: string | null;
          groupActivityId: string | null;
          userId: string | null;
          message: string | null;
          createdAtText: string | null;
          isEdit: boolean | null;
          isRemove: boolean | null;
          user: {id: string | null; fullName: string | null} | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type AddGroupCommentMutationVariables = Exact<{
  id: string | number;
  attributes: Types.CommentInputType;
}>;

export type AddGroupCommentMutation = {
  addGroupComment: {
    comment: {
      id: string | null;
      groupActivityId: string | null;
      userId: string | null;
      message: string | null;
      createdAtText: string | null;
      isEdit: boolean | null;
      isRemove: boolean | null;
      user: {id: string | null; fullName: string | null} | null;
    } | null;
  } | null;
};

export type CreateGroupMutationVariables = Exact<{
  group: Types.GroupInputType;
}>;

export type CreateGroupMutation = {
  createGroup: {
    group: {
      id: string | null;
      name: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      content: string | null;
      location: string | null;
      owner: string | null;
      isAdmin: boolean | null;
      groupAdminCount: number | null;
      groupMemberCount: number | null;
      groupFollowerCount: number | null;
    } | null;
  } | null;
};

export type CreateRequestMutationVariables = Exact<{
  request: Types.RequestInputType;
}>;

export type CreateRequestMutation = {
  createRequest: {
    group: {
      id: string | null;
      name: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      content: string | null;
      location: string | null;
      owner: string | null;
      isAdmin: boolean | null;
      groupAdminCount: number | null;
      groupMemberCount: number | null;
      groupFollowerCount: number | null;
    } | null;
  } | null;
};

export type DestroyGroupUserMutationVariables = Exact<{
  id: string | number;
}>;

export type DestroyGroupUserMutation = {
  destroyGroupUser: {
    group: {
      id: string | null;
      groupAdmins: Array<{
        id: string | null;
        user: {
          id: string | null;
          email: string | null;
          fullName: string | null;
        } | null;
      } | null> | null;
      groupMembers: Array<{
        id: string | null;
        user: {
          id: string | null;
          email: string | null;
          fullName: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type FollowMutationVariables = Exact<{
  groupId: string | number;
}>;

export type FollowMutation = {
  follow: {
    group: {
      id: string | null;
      isFollower: boolean | null;
      groupFollowerCount: number | null;
      followers: Array<{
        id: string | null;
        userId: string | null;
        groupId: string | null;
        user: {id: string | null; fullName: string | null} | null;
      } | null> | null;
    } | null;
  } | null;
};

export type RejectRequestMutationVariables = Exact<{
  id: string | number;
}>;

export type RejectRequestMutation = {
  rejectRequest: {
    request: {
      id: string | null;
      groupId: string | null;
      userId: string | null;
      status: string | null;
    } | null;
  } | null;
};

export type RemoveGroupActivityMutationVariables = Exact<{
  id: string | number;
}>;

export type RemoveGroupActivityMutation = {
  removeGroupActivity: {
    group: {
      id: string | null;
      isAdmin: boolean | null;
      name: string | null;
      activities: Array<{
        id: string | null;
        groupId: string | null;
        userId: string | null;
        title: string | null;
        comments: Array<{
          id: string | null;
          groupActivityId: string | null;
          userId: string | null;
          message: string | null;
          createdAtText: string | null;
          isEdit: boolean | null;
          isRemove: boolean | null;
          user: {id: string | null; fullName: string | null} | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type RemoveGroupCommentMutationVariables = Exact<{
  id: string | number;
}>;

export type RemoveGroupCommentMutation = {
  removeGroupComment: {
    comment: {
      id: string | null;
      groupActivityId: string | null;
      userId: string | null;
      message: string | null;
      createdAtText: string | null;
      isEdit: boolean | null;
      isRemove: boolean | null;
      user: {id: string | null; fullName: string | null} | null;
    } | null;
  } | null;
};

export type SendGroupMailMutationVariables = Exact<{
  groupMail: Types.GroupMailInputType;
}>;

export type SendGroupMailMutation = {
  sendGroupMail: {groupMail: {id: string | null} | null} | null;
};

export type UnfollowMutationVariables = Exact<{
  groupId: string | number;
}>;

export type UnfollowMutation = {
  unfollow: {
    group: {
      id: string | null;
      isFollower: boolean | null;
      groupFollowerCount: number | null;
      followers: Array<{
        id: string | null;
        userId: string | null;
        groupId: string | null;
        user: {id: string | null; fullName: string | null} | null;
      } | null> | null;
    } | null;
  } | null;
};

export type UpdateGroupMutationVariables = Exact<{
  id: string | number;
  group: Types.GroupInputType;
  file?: any;
}>;

export type UpdateGroupMutation = {
  updateGroup: {
    group: {
      id: string | null;
      name: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      content: string | null;
      location: string | null;
      owner: string | null;
      isAdmin: boolean | null;
      groupAdminCount: number | null;
      groupMemberCount: number | null;
      groupFollowerCount: number | null;
    } | null;
  } | null;
};

export type UpdateGroupActivityMutationVariables = Exact<{
  id: string | number;
  attributes: Types.GroupActivityAttributes;
}>;

export type UpdateGroupActivityMutation = {
  updateGroupActivity: {
    groupActivity: {id: string | null; title: string | null} | null;
  } | null;
};

export type UpdateGroupCommentMutationVariables = Exact<{
  id: string | number;
  attributes: Types.CommentInputType;
}>;

export type UpdateGroupCommentMutation = {
  updateGroupComment: {
    comment: {
      id: string | null;
      message: string | null;
      isEdit: boolean | null;
      isRemove: boolean | null;
    } | null;
  } | null;
};

export type UpdateGroupUserMutationVariables = Exact<{
  id: string | number;
  groupUser: Types.GroupUserInputType;
}>;

export type UpdateGroupUserMutation = {
  updateGroupUser: {
    group: {
      id: string | null;
      groupAdmins: Array<{
        id: string | null;
        user: {
          id: string | null;
          email: string | null;
          fullName: string | null;
        } | null;
      } | null> | null;
      groupMembers: Array<{
        id: string | null;
        user: {
          id: string | null;
          email: string | null;
          fullName: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CreateNotificationMutationVariables = Exact<{
  attributes: Types.NotificationAttributes;
}>;

export type CreateNotificationMutation = {
  createNotification: {
    notification: {
      id: string | null;
      status: string | null;
      statusText: string | null;
      message: string | null;
      startDate: any;
      endDate: any;
      startDateText: any;
      endDateText: any;
    } | null;
  } | null;
};

export type UpdateNotificationMutationVariables = Exact<{
  id: string | number;
  attributes: Types.NotificationAttributes;
}>;

export type UpdateNotificationMutation = {
  updateNotification: {
    notification: {
      id: string | null;
      status: string | null;
      statusText: string | null;
      message: string | null;
      startDate: any;
      endDate: any;
      startDateText: any;
      endDateText: any;
    } | null;
  } | null;
};

export type CancelOrderMutationVariables = Exact<{
  id: string | number;
}>;

export type CancelOrderMutation = {
  cancelOrder: {
    error: string | null;
    order: {
      id: string | null;
      workflowState: string | null;
      workflowStateText: string | null;
      totalPrice: number | null;
      completedAtText: string | null;
      chargeId: string | null;
      paymentState: string | null;
      paymentStateText: string | null;
    } | null;
  } | null;
};

export type MarkOrderPaidMutationVariables = Exact<{
  id: string | number;
}>;

export type MarkOrderPaidMutation = {
  markOrderPaid: {
    error: string | null;
    order: {
      id: string | null;
      workflowState: string | null;
      workflowStateText: string | null;
      totalPrice: number | null;
      completedAtText: string | null;
      chargeId: string | null;
      paymentState: string | null;
      paymentStateText: string | null;
    } | null;
  } | null;
};

export type CreatePaymentMutationVariables = Exact<{
  attributes: Types.PaymentInputType;
}>;

export type CreatePaymentMutation = {
  createPayment: {
    error: string | null;
    payment: {
      id: string | null;
      eventId: string | null;
      paymentMethod: string | null;
    } | null;
  } | null;
};

export type UpdatePaymentMutationVariables = Exact<{
  id: string | number;
  attributes: Types.PaymentInputType;
}>;

export type UpdatePaymentMutation = {
  updatePayment: {
    error: string | null;
    payment: {
      id: string | null;
      eventId: string | null;
      paymentMethod: string | null;
    } | null;
  } | null;
};

export type CreateRoomCalendarMutationVariables = Exact<{
  roomCalendar: Types.RoomCalendarInputType;
}>;

export type CreateRoomCalendarMutation = {
  createRoomCalendar: {
    error: string | null;
    roomCalendar: {
      id: string | null;
      roomId: string | null;
      eventId: string | null;
      targetDate: any;
      startTime: string | null;
      startTimeText: string | null;
      endTime: string | null;
      endTimeText: string | null;
      targetDateText: string | null;
      calendarType: string | null;
      memo: string | null;
      event: {
        id: string | null;
        groupId: string | null;
        title: string | null;
        description: string | null;
        eventDate: any;
        eventDatetimeText: string | null;
        eventDateText: string | null;
        eventDateWday: string | null;
        startTimeText: string | null;
        mainImage: string | null;
        mainImageUrl: string | null;
        eventStatus: string | null;
        eventStatusText: string | null;
        paymentStatus: string | null;
        paymentStatusText: string | null;
        akerunStatus: string | null;
        akerunStatusText: string | null;
        locationType: string | null;
        locationTypeText: string | null;
        location: string | null;
        ticketQuantity: number | null;
        ticketAmount: number | null;
        isFree: boolean | null;
        dueDate: any;
        dueDateText: string | null;
        dueTime: string | null;
        dueTimeText: string | null;
        address: string | null;
        organizer: string | null;
        informationEmail: string | null;
        informationTel: string | null;
        acmPrice: number | null;
        taxAcmPrice: number | null;
        guestCount: number | null;
        cancelDate: string | null;
        cancelDateText: string | null;
        cancelTime: string | null;
        cancelTimeText: string | null;
        canCancel: boolean | null;
        onShowpage: boolean | null;
        isShowEventList: boolean | null;
        eventType: string | null;
        eventTypeText: string | null;
        chargeId: string | null;
        ticketPaymentMethod: string | null;
        ticketPaymentMethodText: string | null;
        ownerPaymentStatus: string | null;
        ownerPaymentStatusText: string | null;
        isReceipt: boolean | null;
        receiptName: string | null;
        ownerPaymentDate: string | null;
        receiptStatus: string | null;
        receiptStatusText: string | null;
        orderCount: number | null;
        totalSalesPrice: number | null;
        totalFee: number | null;
        totalPaymentPrice: number | null;
      } | null;
    } | null;
  } | null;
};

export type RemoveRoomCalendarMutationVariables = Exact<{
  id: string | number;
}>;

export type RemoveRoomCalendarMutation = {
  removeRoomCalendar: {id: string | null; error: string | null} | null;
};

export type UpdateRoomCalendarMutationVariables = Exact<{
  id: string | number;
  attributes: Types.RoomCalendarInputType;
}>;

export type UpdateRoomCalendarMutation = {
  updateRoomCalendar: {
    roomCalendar: {
      id: string | null;
      roomId: string | null;
      eventId: string | null;
      targetDate: any;
      startTime: string | null;
      startTimeText: string | null;
      endTime: string | null;
      endTimeText: string | null;
      targetDateText: string | null;
      calendarType: string | null;
      memo: string | null;
    } | null;
  } | null;
};

export type ActivateUserMutationVariables = Exact<{
  id: string | number;
}>;

export type ActivateUserMutation = {
  activateUser: {
    user: {
      id: string | null;
      email: string | null;
      avatar: string | null;
      fullName: string | null;
      createdAtText: string | null;
      updatedAtText: string | null;
      deactivatedAtText: string | null;
    } | null;
  } | null;
};

export type DeactivateUserMutationVariables = Exact<{
  id: string | number;
}>;

export type DeactivateUserMutation = {
  deactivateUser: {
    user: {
      id: string | null;
      email: string | null;
      avatar: string | null;
      fullName: string | null;
      createdAtText: string | null;
      updatedAtText: string | null;
      deactivatedAtText: string | null;
    } | null;
  } | null;
};

export type UpdateAddressMutationVariables = Exact<{
  id: string | number;
  attributes?: Types.AddressInputType | null | undefined;
}>;

export type UpdateAddressMutation = {
  updateAddress: {
    address: {
      id: string | null;
      orderId: string | null;
      userId: string | null;
      industryTypeId: string | null;
      firstName: string | null;
      lastName: string | null;
      gender: string | null;
      genderText: string | null;
      birthdayYear: string | null;
      birthdayMonth: string | null;
      birthdayDay: string | null;
      tel: string | null;
      zipcode: string | null;
      address1: string | null;
      address2: string | null;
      companyName: string | null;
      companyNameKana: string | null;
      companyBranchName: string | null;
      companyPosition: string | null;
      companyTel: string | null;
      companyFax: string | null;
    } | null;
  } | null;
};

export type UpdatePasswordMutationVariables = Exact<{
  id: string | number;
  attributes: Types.UserInputType;
}>;

export type UpdatePasswordMutation = {
  updatePassword: {
    error: string | null;
    user: {
      id: string | null;
      email: string | null;
      avatar: string | null;
      fullName: string | null;
      createdAtText: string | null;
      updatedAtText: string | null;
      deactivatedAtText: string | null;
    } | null;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  id: string | number;
  file?: any;
  user?: Types.UserInputType | null | undefined;
}>;

export type UpdateUserMutation = {
  updateUser: {
    user: {
      id: string | null;
      email: string | null;
      avatar: string | null;
      fullName: string | null;
      createdAtText: string | null;
      updatedAtText: string | null;
      deactivatedAtText: string | null;
    } | null;
  } | null;
};

export type BankQueryVariables = Exact<{[key: string]: never}>;

export type BankQuery = {
  bank: {
    id: string | null;
    userId: string | null;
    name: string | null;
    branch: string | null;
    accountType: string | null;
    accountTypeText: string | null;
    accountNumber: string | null;
    accountName: string | null;
  } | null;
};

export type CurrentOrderQueryVariables = Exact<{[key: string]: never}>;

export type CurrentOrderQuery = {
  currentOrder: {
    id: string | null;
    workflowState: string | null;
    workflowStateText: string | null;
    totalPrice: number | null;
    completedAtText: string | null;
    chargeId: string | null;
    paymentState: string | null;
    paymentStateText: string | null;
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
      eventSchedules: Array<{
        id: string | null;
        eventId: string | null;
        eventDate: any;
        eventDateText: string | null;
        eventDateTextFull: string | null;
        eventDateWday: string | null;
        startTime: string | null;
        startTimeText: string | null;
        endTime: string | null;
        endTimeText: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CurrentUserQueryVariables = Exact<{[key: string]: never}>;

export type CurrentUserQuery = {
  currentUser: {
    id: string | null;
    email: string | null;
    avatar: string | null;
    fullName: string | null;
    createdAtText: string | null;
    updatedAtText: string | null;
    deactivatedAtText: string | null;
    payjpCustomer: {
      id: string | null;
      card: {
        id: string | null;
        cardId: string | null;
        customerId: string | null;
        created: number | null;
        name: string | null;
        last4: string | null;
        expMonth: string | null;
        expYear: string | null;
      } | null;
    } | null;
    address: {
      id: string | null;
      orderId: string | null;
      userId: string | null;
      industryTypeId: string | null;
      firstName: string | null;
      lastName: string | null;
      gender: string | null;
      genderText: string | null;
      birthdayYear: string | null;
      birthdayMonth: string | null;
      birthdayDay: string | null;
      tel: string | null;
      zipcode: string | null;
      address1: string | null;
      address2: string | null;
      companyName: string | null;
      companyNameKana: string | null;
      companyBranchName: string | null;
      companyPosition: string | null;
      companyTel: string | null;
      companyFax: string | null;
      industryType: {id: string | null} | null;
    } | null;
  } | null;
};

export type DoorKeyQueryVariables = Exact<{
  token: string;
}>;

export type DoorKeyQuery = {
  doorKey: {
    state: string;
    guestName: string | null;
    spaceName: string | null;
    windows: Array<{unlockText: string; useText: string}>;
  };
};

export type AdminDoorKeyQueryVariables = Exact<{
  id: string | number;
}>;

export type AdminDoorKeyQuery = {
  adminDoorKey: {
    id: string;
    keyNumber: string;
    target: string;
    targetName: string;
    reservationNumber: string;
    eventId: string | null;
    url: string;
    guestName: string;
    guestEmail: string;
    spaceName: string;
    status: string;
    issuedAt: any;
    mailSentAt: any;
    lastUnlockedAt: any;
    revokedAt: any;
    revokedByName: string | null;
    reissuable: boolean;
    windows: Array<{unlockText: string; useText: string}>;
    activities: Array<{
      id: string;
      createdAt: any;
      actionName: string;
      actorName: string;
      succeeded: boolean;
      detail: string | null;
    }>;
  } | null;
};

export type DoorKeyWebhookReceiptsQueryVariables = Exact<{
  results?: Array<string> | string | null | undefined;
}>;

export type DoorKeyWebhookReceiptsQuery = {
  doorKeyWebhookReceipts: Array<{
    id: string;
    createdAt: any;
    externalReservationId: string | null;
    guestName: string | null;
    startsAt: any;
    endsAt: any;
    result: string;
    resultName: string;
    reason: string | null;
    doorKey: {id: string; keyNumber: string} | null;
  }>;
};

export type DoorKeysQueryVariables = Exact<{
  page: number;
  search?: Types.DoorKeySearch | null | undefined;
}>;

export type DoorKeysQuery = {
  doorKeys: {
    doorKeys: Array<{
      id: string;
      keyNumber: string;
      target: string;
      targetName: string;
      reservationNumber: string;
      eventId: string | null;
      url: string;
      guestName: string;
      guestEmail: string;
      spaceName: string;
      status: string;
      issuedAt: any;
      mailSentAt: any;
      lastUnlockedAt: any;
      revokedAt: any;
      revokedByName: string | null;
      reissuable: boolean;
      windows: Array<{unlockText: string; useText: string}>;
      activities: Array<{
        id: string;
        createdAt: any;
        actionName: string;
        actorName: string;
        succeeded: boolean;
        detail: string | null;
      }>;
    }>;
    pagination: {
      resultsCount: number | null;
      totalCount: number | null;
      totalPages: number | null;
      currentPage: number | null;
      nextPage: number | null;
      previousPage: number | null;
      hasNextPage: boolean | null;
      hasPreviousPage: boolean | null;
    };
  };
};

export type DoorLockHistoryQueryVariables = Exact<{
  target: string;
}>;

export type DoorLockHistoryQuery = {
  doorLockHistory: Array<{
    at: any;
    operation: string;
    via: string;
    tag: string | null;
    doorKey: {id: string; guestName: string} | null;
  }>;
};

export type DoorLocksQueryVariables = Exact<{[key: string]: never}>;

export type DoorLocksQuery = {
  doorLocks: Array<{
    target: string;
    targetName: string;
    batteryPercentage: number | null;
    lockStatus: string | null;
    fetchedAt: any;
    lowBattery: boolean;
    lowBatteryThreshold: number;
  }>;
};

export type EventQueryVariables = Exact<{
  id: string | number;
}>;

export type EventQuery = {
  myEvents: Array<{
    id: string | null;
    groupId: string | null;
    title: string | null;
    description: string | null;
    eventDate: any;
    eventDatetimeText: string | null;
    eventDateText: string | null;
    eventDateWday: string | null;
    startTimeText: string | null;
    mainImage: string | null;
    mainImageUrl: string | null;
    eventStatus: string | null;
    eventStatusText: string | null;
    paymentStatus: string | null;
    paymentStatusText: string | null;
    akerunStatus: string | null;
    akerunStatusText: string | null;
    locationType: string | null;
    locationTypeText: string | null;
    location: string | null;
    ticketQuantity: number | null;
    ticketAmount: number | null;
    isFree: boolean | null;
    dueDate: any;
    dueDateText: string | null;
    dueTime: string | null;
    dueTimeText: string | null;
    address: string | null;
    organizer: string | null;
    informationEmail: string | null;
    informationTel: string | null;
    acmPrice: number | null;
    taxAcmPrice: number | null;
    guestCount: number | null;
    cancelDate: string | null;
    cancelDateText: string | null;
    cancelTime: string | null;
    cancelTimeText: string | null;
    canCancel: boolean | null;
    onShowpage: boolean | null;
    isShowEventList: boolean | null;
    eventType: string | null;
    eventTypeText: string | null;
    chargeId: string | null;
    ticketPaymentMethod: string | null;
    ticketPaymentMethodText: string | null;
    ownerPaymentStatus: string | null;
    ownerPaymentStatusText: string | null;
    isReceipt: boolean | null;
    receiptName: string | null;
    ownerPaymentDate: string | null;
    receiptStatus: string | null;
    receiptStatusText: string | null;
    orderCount: number | null;
    totalSalesPrice: number | null;
    totalFee: number | null;
    totalPaymentPrice: number | null;
  } | null>;
  event: {
    overFirstEventDate: boolean | null;
    groupId: string | null;
    id: string | null;
    title: string | null;
    description: string | null;
    eventDate: any;
    eventDatetimeText: string | null;
    eventDateText: string | null;
    eventDateWday: string | null;
    startTimeText: string | null;
    mainImage: string | null;
    mainImageUrl: string | null;
    eventStatus: string | null;
    eventStatusText: string | null;
    paymentStatus: string | null;
    paymentStatusText: string | null;
    akerunStatus: string | null;
    akerunStatusText: string | null;
    locationType: string | null;
    locationTypeText: string | null;
    location: string | null;
    ticketQuantity: number | null;
    ticketAmount: number | null;
    isFree: boolean | null;
    dueDate: any;
    dueDateText: string | null;
    dueTime: string | null;
    dueTimeText: string | null;
    address: string | null;
    organizer: string | null;
    informationEmail: string | null;
    informationTel: string | null;
    acmPrice: number | null;
    taxAcmPrice: number | null;
    guestCount: number | null;
    cancelDate: string | null;
    cancelDateText: string | null;
    cancelTime: string | null;
    cancelTimeText: string | null;
    canCancel: boolean | null;
    onShowpage: boolean | null;
    isShowEventList: boolean | null;
    eventType: string | null;
    eventTypeText: string | null;
    chargeId: string | null;
    ticketPaymentMethod: string | null;
    ticketPaymentMethodText: string | null;
    ownerPaymentStatus: string | null;
    ownerPaymentStatusText: string | null;
    isReceipt: boolean | null;
    receiptName: string | null;
    ownerPaymentDate: string | null;
    receiptStatus: string | null;
    receiptStatusText: string | null;
    orderCount: number | null;
    totalSalesPrice: number | null;
    totalFee: number | null;
    totalPaymentPrice: number | null;
    eventSchedules: Array<{
      id: string | null;
      eventId: string | null;
      eventDate: any;
      eventDateText: string | null;
      eventDateTextFull: string | null;
      eventDateWday: string | null;
      startTime: string | null;
      startTimeText: string | null;
      endTime: string | null;
      endTimeText: string | null;
    } | null> | null;
    acceptedOrders: Array<{
      id: string | null;
      workflowState: string | null;
      workflowStateText: string | null;
      totalPrice: number | null;
      completedAtText: string | null;
      chargeId: string | null;
      paymentState: string | null;
      paymentStateText: string | null;
      user: {
        id: string | null;
        email: string | null;
        avatar: string | null;
        fullName: string | null;
        createdAtText: string | null;
        updatedAtText: string | null;
        deactivatedAtText: string | null;
        payjpCustomer: {
          id: string | null;
          userId: string | null;
          customerId: string | null;
        } | null;
        address: {
          id: string | null;
          userId: string | null;
          tel: string | null;
        } | null;
      } | null;
    } | null> | null;
    user: {
      id: string | null;
      email: string | null;
      avatar: string | null;
      fullName: string | null;
      createdAtText: string | null;
      updatedAtText: string | null;
      deactivatedAtText: string | null;
      payjpCustomer: {
        id: string | null;
        userId: string | null;
        customerId: string | null;
      } | null;
      address: {
        id: string | null;
        orderId: string | null;
        userId: string | null;
        industryTypeId: string | null;
        firstName: string | null;
        lastName: string | null;
        gender: string | null;
        genderText: string | null;
        birthdayYear: string | null;
        birthdayMonth: string | null;
        birthdayDay: string | null;
        tel: string | null;
        zipcode: string | null;
        address1: string | null;
        address2: string | null;
        companyName: string | null;
        companyNameKana: string | null;
        companyBranchName: string | null;
        companyPosition: string | null;
        companyTel: string | null;
        companyFax: string | null;
        industryType: {id: string | null; name: string | null} | null;
      } | null;
      bank: {
        id: string | null;
        userId: string | null;
        name: string | null;
        branch: string | null;
        accountType: string | null;
        accountTypeText: string | null;
        accountNumber: string | null;
        accountName: string | null;
      } | null;
    } | null;
    roomCalendars: Array<{
      id: string | null;
      roomId: string | null;
      eventId: string | null;
      targetDate: any;
      startTime: string | null;
      startTimeText: string | null;
      endTime: string | null;
      endTimeText: string | null;
      targetDateText: string | null;
      calendarType: string | null;
      memo: string | null;
      room: {id: string | null; name: string | null} | null;
    } | null> | null;
    eventOptions: Array<{
      id: string | null;
      eventId: string | null;
      optionId: string | null;
      isApply: boolean | null;
      option: {
        id: string | null;
        name: string | null;
        optionType: string | null;
        description: string | null;
      } | null;
    } | null> | null;
    payment: {
      id: string | null;
      eventId: string | null;
      paymentMethod: string | null;
      payjpCard: {
        id: string | null;
        cardId: string | null;
        last4: string | null;
        expMonth: string | null;
        expYear: string | null;
      } | null;
    } | null;
    group: {
      id: string | null;
      name: string | null;
      mainImageUrl: string | null;
      followers: Array<{
        id: string | null;
        groupId: string | null;
        userId: string | null;
      } | null> | null;
    } | null;
  } | null;
  options: Array<{
    id: string | null;
    name: string | null;
    optionType: string | null;
    description: string | null;
  }> | null;
  rooms: Array<{id: string | null; name: string | null} | null> | null;
};

export type EventsQueryVariables = Exact<{
  page: number;
  search?: Types.EventSearch | null | undefined;
}>;

export type EventsQuery = {
  events: {
    events: Array<{
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
      eventSchedules: Array<{
        id: string | null;
        eventId: string | null;
        eventDate: any;
        eventDateText: string | null;
        eventDateTextFull: string | null;
        eventDateWday: string | null;
        startTime: string | null;
        startTimeText: string | null;
        endTime: string | null;
        endTimeText: string | null;
      } | null> | null;
      user: {
        id: string | null;
        email: string | null;
        avatar: string | null;
        fullName: string | null;
        createdAtText: string | null;
        updatedAtText: string | null;
        deactivatedAtText: string | null;
      } | null;
      payment: {
        id: string | null;
        eventId: string | null;
        paymentMethod: string | null;
      } | null;
    } | null> | null;
    pagination: {
      resultsCount: number | null;
      totalCount: number | null;
      totalPages: number | null;
      currentPage: number | null;
      nextPage: number | null;
      previousPage: number | null;
      hasNextPage: boolean | null;
      hasPreviousPage: boolean | null;
    } | null;
  } | null;
};

export type MyEventsQueryVariables = Exact<{[key: string]: never}>;

export type MyEventsQuery = {
  myEvents: Array<{
    id: string | null;
    groupId: string | null;
    title: string | null;
    description: string | null;
    eventDate: any;
    eventDatetimeText: string | null;
    eventDateText: string | null;
    eventDateWday: string | null;
    startTimeText: string | null;
    mainImage: string | null;
    mainImageUrl: string | null;
    eventStatus: string | null;
    eventStatusText: string | null;
    paymentStatus: string | null;
    paymentStatusText: string | null;
    akerunStatus: string | null;
    akerunStatusText: string | null;
    locationType: string | null;
    locationTypeText: string | null;
    location: string | null;
    ticketQuantity: number | null;
    ticketAmount: number | null;
    isFree: boolean | null;
    dueDate: any;
    dueDateText: string | null;
    dueTime: string | null;
    dueTimeText: string | null;
    address: string | null;
    organizer: string | null;
    informationEmail: string | null;
    informationTel: string | null;
    acmPrice: number | null;
    taxAcmPrice: number | null;
    guestCount: number | null;
    cancelDate: string | null;
    cancelDateText: string | null;
    cancelTime: string | null;
    cancelTimeText: string | null;
    canCancel: boolean | null;
    onShowpage: boolean | null;
    isShowEventList: boolean | null;
    eventType: string | null;
    eventTypeText: string | null;
    chargeId: string | null;
    ticketPaymentMethod: string | null;
    ticketPaymentMethodText: string | null;
    ownerPaymentStatus: string | null;
    ownerPaymentStatusText: string | null;
    isReceipt: boolean | null;
    receiptName: string | null;
    ownerPaymentDate: string | null;
    receiptStatus: string | null;
    receiptStatusText: string | null;
    orderCount: number | null;
    totalSalesPrice: number | null;
    totalFee: number | null;
    totalPaymentPrice: number | null;
    eventSchedules: Array<{
      id: string | null;
      eventId: string | null;
      eventDate: any;
      eventDateText: string | null;
      eventDateTextFull: string | null;
      eventDateWday: string | null;
      startTime: string | null;
      startTimeText: string | null;
      endTime: string | null;
      endTimeText: string | null;
    } | null> | null;
    group: {id: string | null; name: string | null} | null;
  } | null>;
};

export type GroupQueryVariables = Exact<{
  id: string | number;
}>;

export type GroupQuery = {
  myGroups: Array<{
    id: string | null;
    name: string | null;
    mainImage: string | null;
    mainImageUrl: string | null;
    content: string | null;
    location: string | null;
    owner: string | null;
    isAdmin: boolean | null;
    groupAdminCount: number | null;
    groupMemberCount: number | null;
    groupFollowerCount: number | null;
  } | null>;
  group: {
    myRequestStatus: string | null;
    id: string | null;
    name: string | null;
    mainImage: string | null;
    mainImageUrl: string | null;
    content: string | null;
    location: string | null;
    owner: string | null;
    isAdmin: boolean | null;
    groupAdminCount: number | null;
    groupMemberCount: number | null;
    groupFollowerCount: number | null;
    users: Array<{
      id: string | null;
      email: string | null;
      fullName: string | null;
    } | null> | null;
    requests: Array<{
      id: string | null;
      groupId: string | null;
      userId: string | null;
      status: string | null;
      createdAtText: string | null;
      user: {
        id: string | null;
        email: string | null;
        avatar: string | null;
        fullName: string | null;
        createdAtText: string | null;
        updatedAtText: string | null;
        deactivatedAtText: string | null;
      } | null;
    } | null> | null;
    groupAdmins: Array<{
      id: string | null;
      user: {
        id: string | null;
        email: string | null;
        fullName: string | null;
      } | null;
    } | null> | null;
    groupMembers: Array<{
      id: string | null;
      user: {
        id: string | null;
        email: string | null;
        fullName: string | null;
      } | null;
    } | null> | null;
    groupUsers: Array<{
      id: string | null;
      role: string | null;
      user: {
        id: string | null;
        email: string | null;
        fullName: string | null;
      } | null;
    } | null> | null;
    followers: Array<{
      id: string | null;
      userId: string | null;
      groupId: string | null;
      user: {
        id: string | null;
        email: string | null;
        fullName: string | null;
      } | null;
    } | null> | null;
    activities: Array<{
      id: string | null;
      groupId: string | null;
      userId: string | null;
      title: string | null;
      comments: Array<{
        id: string | null;
        groupActivityId: string | null;
        userId: string | null;
        message: string | null;
        createdAtText: string | null;
        isEdit: boolean | null;
        isRemove: boolean | null;
        user: {
          id: string | null;
          fullName: string | null;
          avatar: string | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GroupDetailQueryVariables = Exact<{
  id: string | number;
}>;

export type GroupDetailQuery = {
  group: {
    isMember: boolean | null;
    isFollower: boolean | null;
    myRequestStatus: string | null;
    id: string | null;
    name: string | null;
    mainImage: string | null;
    mainImageUrl: string | null;
    content: string | null;
    location: string | null;
    owner: string | null;
    isAdmin: boolean | null;
    groupAdminCount: number | null;
    groupMemberCount: number | null;
    groupFollowerCount: number | null;
    groupUsers: Array<{
      id: string | null;
      role: string | null;
      user: {id: string | null; fullName: string | null} | null;
    } | null> | null;
    followers: Array<{
      id: string | null;
      user: {id: string | null; fullName: string | null} | null;
    } | null> | null;
  } | null;
};

export type GroupFeatureEventsQueryVariables = Exact<{
  id: string | number;
}>;

export type GroupFeatureEventsQuery = {
  groupFeatureEvents: Array<{
    id: string | null;
    title: string | null;
    mainImage: string | null;
    mainImageUrl: string | null;
    eventStatus: string | null;
    eventStatusText: string | null;
    eventDateText: string | null;
    eventDateWday: string | null;
    startTimeText: string | null;
    location: string | null;
    locationType: string | null;
    locationTypeText: string | null;
    organizer: string | null;
  } | null>;
};

export type GroupPastEventsQueryVariables = Exact<{
  id: string | number;
}>;

export type GroupPastEventsQuery = {
  groupPastEvents: Array<{
    id: string | null;
    title: string | null;
    mainImage: string | null;
    mainImageUrl: string | null;
    eventStatus: string | null;
    eventStatusText: string | null;
    eventDateText: string | null;
    eventDateWday: string | null;
    startTimeText: string | null;
    lastEventDateText: string | null;
    lastEventDateWday: string | null;
    lastStartTimeText: string | null;
    location: string | null;
    locationType: string | null;
    locationTypeText: string | null;
    organizer: string | null;
  } | null>;
};

export type GroupsQueryVariables = Exact<{
  page?: number | null | undefined;
  perPage?: number | null | undefined;
}>;

export type GroupsQuery = {
  groups: {
    groups: Array<{
      id: string | null;
      name: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      content: string | null;
      location: string | null;
      owner: string | null;
      isAdmin: boolean | null;
      groupAdminCount: number | null;
      groupMemberCount: number | null;
      groupFollowerCount: number | null;
      groupAdmins: Array<{
        id: string | null;
        user: {
          id: string | null;
          email: string | null;
          fullName: string | null;
        } | null;
      } | null> | null;
    } | null> | null;
    pagination: {
      resultsCount: number | null;
      totalCount: number | null;
      totalPages: number | null;
      currentPage: number | null;
      nextPage: number | null;
      previousPage: number | null;
      hasNextPage: boolean | null;
      hasPreviousPage: boolean | null;
    } | null;
  } | null;
};

export type MyFollowsQueryVariables = Exact<{[key: string]: never}>;

export type MyFollowsQuery = {
  myFollows: Array<{
    id: string | null;
    isAdmin: boolean | null;
    name: string | null;
    mainImage: string | null;
    mainImageUrl: string | null;
    groupAdminCount: number | null;
    groupMemberCount: number | null;
    groupFollowerCount: number | null;
  } | null>;
};

export type MyGroupsQueryVariables = Exact<{[key: string]: never}>;

export type MyGroupsQuery = {
  myGroups: Array<{
    id: string | null;
    name: string | null;
    mainImage: string | null;
    mainImageUrl: string | null;
    content: string | null;
    location: string | null;
    owner: string | null;
    isAdmin: boolean | null;
    groupAdminCount: number | null;
    groupMemberCount: number | null;
    groupFollowerCount: number | null;
    users: Array<{
      id: string | null;
      email: string | null;
      fullName: string | null;
    } | null> | null;
    groupAdmins: Array<{id: string | null} | null> | null;
    groupMembers: Array<{id: string | null} | null> | null;
    followers: Array<{id: string | null} | null> | null;
  } | null>;
};

export type IndustryTypesQueryVariables = Exact<{[key: string]: never}>;

export type IndustryTypesQuery = {
  industryTypes: Array<{id: string | null; name: string | null} | null> | null;
};

export type NotificationsQueryVariables = Exact<{
  page?: number | null | undefined;
  perPage?: number | null | undefined;
}>;

export type NotificationsQuery = {
  notifications: {
    notifications: Array<{
      id: string | null;
      status: string | null;
      statusText: string | null;
      message: string | null;
      startDate: any;
      endDate: any;
      startDateText: any;
      endDateText: any;
    } | null> | null;
    pagination: {
      resultsCount: number | null;
      totalCount: number | null;
      totalPages: number | null;
      currentPage: number | null;
      nextPage: number | null;
      previousPage: number | null;
      hasNextPage: boolean | null;
      hasPreviousPage: boolean | null;
    } | null;
  } | null;
};

export type OptionsQueryVariables = Exact<{
  search?: Types.OptionSearch | null | undefined;
}>;

export type OptionsQuery = {
  options: Array<{
    id: string | null;
    optionType: string | null;
    name: string | null;
    description: string | null;
  }> | null;
};

export type MyEntryOrdersQueryVariables = Exact<{[key: string]: never}>;

export type MyEntryOrdersQuery = {
  myEntryOrders: Array<{
    id: string | null;
    workflowState: string | null;
    workflowStateText: string | null;
    totalPrice: number | null;
    completedAtText: string | null;
    chargeId: string | null;
    paymentState: string | null;
    paymentStateText: string | null;
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
      eventSchedules: Array<{
        id: string | null;
        eventId: string | null;
        eventDate: any;
        eventDateText: string | null;
        eventDateTextFull: string | null;
        eventDateWday: string | null;
        startTime: string | null;
        startTimeText: string | null;
        endTime: string | null;
        endTimeText: string | null;
      } | null> | null;
    } | null;
  } | null>;
};

export type PublicEventQueryVariables = Exact<{
  id: string | number;
}>;

export type PublicEventQuery = {
  publicEvent: {
    id: string | null;
    title: string | null;
    organizer: string | null;
    description: string | null;
    mainImageUrl: string | null;
    eventStatus: string | null;
    isFree: boolean | null;
    ticketAmount: number | null;
    ticketPaymentMethod: string | null;
    ticketPaymentMethodText: string | null;
    dueDate: any;
    dueDateText: string | null;
    dueDateTextFull: string | null;
    dueTimeText: string | null;
    cancelDate: string | null;
    cancelDateText: string | null;
    cancelDateTextFull: string | null;
    cancelTimeText: string | null;
    location: string | null;
    locationType: string | null;
    address: string | null;
    informationEmail: string | null;
    informationTel: string | null;
    canOrder: boolean | null;
    eventSchedules: Array<{
      id: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      endTimeText: string | null;
    } | null> | null;
    group: {
      id: string | null;
      name: string | null;
      mainImageUrl: string | null;
      groupFollowerCount: number | null;
      isFollower: boolean | null;
    } | null;
  } | null;
};

export type PublicEventsQueryVariables = Exact<{[key: string]: never}>;

export type PublicEventsQuery = {
  publicEvents: Array<{
    id: string | null;
    title: string | null;
    organizer: string | null;
    mainImageUrl: string | null;
    eventDateText: string | null;
    eventDateWday: string | null;
    startTimeText: string | null;
    group: {id: string | null; name: string | null} | null;
  } | null>;
};

export type RoomCalendarsQueryVariables = Exact<{
  search: Types.RoomCalendarSearch;
}>;

export type RoomCalendarsQuery = {
  roomCalendars: Array<{
    id: string | null;
    roomId: string | null;
    eventId: string | null;
    targetDate: any;
    startTime: string | null;
    startTimeText: string | null;
    endTime: string | null;
    endTimeText: string | null;
    targetDateText: string | null;
    calendarType: string | null;
    memo: string | null;
    event: {
      id: string | null;
      groupId: string | null;
      title: string | null;
      description: string | null;
      eventDate: any;
      eventDatetimeText: string | null;
      eventDateText: string | null;
      eventDateWday: string | null;
      startTimeText: string | null;
      mainImage: string | null;
      mainImageUrl: string | null;
      eventStatus: string | null;
      eventStatusText: string | null;
      paymentStatus: string | null;
      paymentStatusText: string | null;
      akerunStatus: string | null;
      akerunStatusText: string | null;
      locationType: string | null;
      locationTypeText: string | null;
      location: string | null;
      ticketQuantity: number | null;
      ticketAmount: number | null;
      isFree: boolean | null;
      dueDate: any;
      dueDateText: string | null;
      dueTime: string | null;
      dueTimeText: string | null;
      address: string | null;
      organizer: string | null;
      informationEmail: string | null;
      informationTel: string | null;
      acmPrice: number | null;
      taxAcmPrice: number | null;
      guestCount: number | null;
      cancelDate: string | null;
      cancelDateText: string | null;
      cancelTime: string | null;
      cancelTimeText: string | null;
      canCancel: boolean | null;
      onShowpage: boolean | null;
      isShowEventList: boolean | null;
      eventType: string | null;
      eventTypeText: string | null;
      chargeId: string | null;
      ticketPaymentMethod: string | null;
      ticketPaymentMethodText: string | null;
      ownerPaymentStatus: string | null;
      ownerPaymentStatusText: string | null;
      isReceipt: boolean | null;
      receiptName: string | null;
      ownerPaymentDate: string | null;
      receiptStatus: string | null;
      receiptStatusText: string | null;
      orderCount: number | null;
      totalSalesPrice: number | null;
      totalFee: number | null;
      totalPaymentPrice: number | null;
    } | null;
  } | null>;
  rooms: Array<{id: string | null; closedFrom: any} | null> | null;
};

export type AllUsersQueryVariables = Exact<{[key: string]: never}>;

export type AllUsersQuery = {
  allUsers: Array<{
    id: string | null;
    email: string | null;
    avatar: string | null;
    fullName: string | null;
    createdAtText: string | null;
    updatedAtText: string | null;
    deactivatedAtText: string | null;
    address: {
      id: string | null;
      orderId: string | null;
      userId: string | null;
      industryTypeId: string | null;
      firstName: string | null;
      lastName: string | null;
      gender: string | null;
      genderText: string | null;
      birthdayYear: string | null;
      birthdayMonth: string | null;
      birthdayDay: string | null;
      tel: string | null;
      zipcode: string | null;
      address1: string | null;
      address2: string | null;
      companyName: string | null;
      companyNameKana: string | null;
      companyBranchName: string | null;
      companyPosition: string | null;
      companyTel: string | null;
      companyFax: string | null;
      industryType: {id: string | null; name: string | null} | null;
    } | null;
  }> | null;
};

export const AddressFragmentFragmentDoc = gql`
  fragment addressFragment on AddressType {
    id
    orderId
    userId
    industryTypeId
    firstName
    lastName
    gender
    genderText
    birthdayYear
    birthdayMonth
    birthdayDay
    tel
    zipcode
    address1
    address2
    companyName
    companyNameKana
    companyBranchName
    companyPosition
    companyTel
    companyFax
  }
`;
export const AdminDoorKeyFragmentFragmentDoc = gql`
  fragment adminDoorKeyFragment on AdminDoorKeyType {
    id
    keyNumber
    target
    targetName
    reservationNumber
    eventId
    url
    guestName
    guestEmail
    spaceName
    status
    issuedAt
    mailSentAt
    lastUnlockedAt
    revokedAt
    revokedByName
    reissuable
    windows {
      unlockText
      useText
    }
    activities {
      id
      createdAt
      actionName
      actorName
      succeeded
      detail
    }
  }
`;
export const BankFragmentFragmentDoc = gql`
  fragment bankFragment on BankType {
    id
    userId
    name
    branch
    accountType
    accountTypeText
    accountNumber
    accountName
  }
`;
export const ContactFragmentFragmentDoc = gql`
  fragment contactFragment on Contact {
    id
    firstName
    lastName
    email
    tel
    message
  }
`;
export const PublicDoorKeyFragmentFragmentDoc = gql`
  fragment publicDoorKeyFragment on PublicDoorKeyType {
    state
    guestName
    spaceName
    windows {
      unlockText
      useText
    }
  }
`;
export const EventFragmentFragmentDoc = gql`
  fragment eventFragment on EventType {
    id
    groupId
    title
    description
    eventDate
    eventDatetimeText
    eventDateText
    eventDateWday
    startTimeText
    mainImage
    mainImageUrl
    eventStatus
    eventStatusText
    paymentStatus
    paymentStatusText
    akerunStatus
    akerunStatusText
    locationType
    locationTypeText
    location
    ticketQuantity
    ticketAmount
    isFree
    dueDate
    dueDateText
    dueTime
    dueTimeText
    address
    organizer
    informationEmail
    informationTel
    acmPrice
    taxAcmPrice
    guestCount
    cancelDate
    cancelDateText
    cancelTime
    cancelTimeText
    canCancel
    onShowpage
    isShowEventList
    eventType
    eventTypeText
    chargeId
    ticketPaymentMethod
    ticketPaymentMethodText
    ownerPaymentStatus
    ownerPaymentStatusText
    isReceipt
    receiptName
    ownerPaymentDate
    receiptStatus
    receiptStatusText
    orderCount
    totalSalesPrice
    totalFee
    totalPaymentPrice
  }
`;
export const EventOptionFragmentFragmentDoc = gql`
  fragment eventOptionFragment on EventOptionType {
    id
    eventId
    optionId
    isApply
  }
`;
export const EventScheduleFragmentFragmentDoc = gql`
  fragment eventScheduleFragment on EventScheduleType {
    id
    eventId
    eventDate
    eventDateText
    eventDateTextFull
    eventDateWday
    startTime
    startTimeText
    endTime
    endTimeText
  }
`;
export const GroupFragmentFragmentDoc = gql`
  fragment groupFragment on GroupType {
    id
    name
    mainImage
    mainImageUrl
    content
    location
    owner
    isAdmin
    groupAdminCount
    groupMemberCount
    groupFollowerCount
  }
`;
export const GroupActivityFragmentFragmentDoc = gql`
  fragment groupActivityFragment on GroupActivityType {
    id
    groupId
    userId
    title
  }
`;
export const GroupCommentFragmentFragmentDoc = gql`
  fragment groupCommentFragment on GroupCommentType {
    id
    groupActivityId
    userId
    message
    createdAtText
    isEdit
    isRemove
  }
`;
export const IndustryTypeFragmentFragmentDoc = gql`
  fragment industryTypeFragment on IndustryTypeType {
    id
    name
  }
`;
export const NotificationFragmentFragmentDoc = gql`
  fragment notificationFragment on Notification {
    id
    status
    statusText
    message
    startDate
    endDate
    startDateText
    endDateText
  }
`;
export const OptionFragmentFragmentDoc = gql`
  fragment optionFragment on OptionType {
    id
    optionType
    name
    description
  }
`;
export const OrderFragmentFragmentDoc = gql`
  fragment orderFragment on OrderType {
    id
    workflowState
    workflowStateText
    totalPrice
    completedAtText
    chargeId
    paymentState
    paymentStateText
  }
`;
export const PaginationFragmentFragmentDoc = gql`
  fragment paginationFragment on Pagination {
    resultsCount
    totalCount
    totalPages
    currentPage
    nextPage
    previousPage
    hasNextPage
    hasPreviousPage
  }
`;
export const PayjpCardFragmentFragmentDoc = gql`
  fragment payjpCardFragment on PayjpCardType {
    id
    cardId
    customerId
    created
    name
    last4
    expMonth
    expYear
  }
`;
export const PayjpCustomerFragmentFragmentDoc = gql`
  fragment payjpCustomerFragment on PayjpCustomerType {
    id
    userId
    customerId
  }
`;
export const PaymentFragmentFragmentDoc = gql`
  fragment paymentFragment on PaymentType {
    id
    eventId
    paymentMethod
  }
`;
export const RoomCalendarFragmentFragmentDoc = gql`
  fragment roomCalendarFragment on RoomCalendarType {
    id
    roomId
    eventId
    targetDate
    startTime
    startTimeText
    endTime
    endTimeText
    targetDateText
    calendarType
    memo
  }
`;
export const UserFragmentFragmentDoc = gql`
  fragment userFragment on UserType {
    id
    email
    avatar
    fullName
    createdAtText
    updatedAtText
    deactivatedAtText
  }
`;
export const ChangePasswordDocument = gql`
  mutation changePassword($password: PasswordAttributes!) {
    changePassword(input: {password: $password}) {
      user {
        ...userFragment
      }
      error
    }
  }
  ${UserFragmentFragmentDoc}
`;
export type ChangePasswordMutationFn = Apollo.MutationFunction<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >(ChangePasswordDocument, options);
}
export type ChangePasswordMutationHookResult = ReturnType<
  typeof useChangePasswordMutation
>;
export type ChangePasswordMutationResult =
  Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;
export const ConfirmDocument = gql`
  mutation confirm($token: String!) {
    confirm(input: {token: $token}) {
      user {
        ...userFragment
      }
      error
    }
  }
  ${UserFragmentFragmentDoc}
`;
export type ConfirmMutationFn = Apollo.MutationFunction<
  ConfirmMutation,
  ConfirmMutationVariables
>;

/**
 * __useConfirmMutation__
 *
 * To run a mutation, you first call `useConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMutation, { data, loading, error }] = useConfirmMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useConfirmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmMutation,
    ConfirmMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ConfirmMutation, ConfirmMutationVariables>(
    ConfirmDocument,
    options,
  );
}
export type ConfirmMutationHookResult = ReturnType<typeof useConfirmMutation>;
export type ConfirmMutationResult = Apollo.MutationResult<ConfirmMutation>;
export type ConfirmMutationOptions = Apollo.BaseMutationOptions<
  ConfirmMutation,
  ConfirmMutationVariables
>;
export const RequestPasswordResetDocument = gql`
  mutation requestPasswordReset($email: String!) {
    requestPasswordReset(input: {email: $email}) {
      error
    }
  }
`;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables
>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestPasswordResetMutation,
    RequestPasswordResetMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    RequestPasswordResetMutation,
    RequestPasswordResetMutationVariables
  >(RequestPasswordResetDocument, options);
}
export type RequestPasswordResetMutationHookResult = ReturnType<
  typeof useRequestPasswordResetMutation
>;
export type RequestPasswordResetMutationResult =
  Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables
>;
export const ResetPasswordDocument = gql`
  mutation resetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      error
    }
  }
`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >(ResetPasswordDocument, options);
}
export type ResetPasswordMutationHookResult = ReturnType<
  typeof useResetPasswordMutation
>;
export type ResetPasswordMutationResult =
  Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const SigninDocument = gql`
  mutation signin($email: String!, $password: String!) {
    signin(input: {email: $email, password: $password}) {
      user {
        ...userFragment
      }
      otpRequired
      error
    }
  }
  ${UserFragmentFragmentDoc}
`;
export type SigninMutationFn = Apollo.MutationFunction<
  SigninMutation,
  SigninMutationVariables
>;

/**
 * __useSigninMutation__
 *
 * To run a mutation, you first call `useSigninMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinMutation, { data, loading, error }] = useSigninMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSigninMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SigninMutation,
    SigninMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SigninMutation, SigninMutationVariables>(
    SigninDocument,
    options,
  );
}
export type SigninMutationHookResult = ReturnType<typeof useSigninMutation>;
export type SigninMutationResult = Apollo.MutationResult<SigninMutation>;
export type SigninMutationOptions = Apollo.BaseMutationOptions<
  SigninMutation,
  SigninMutationVariables
>;
export const SignoutDocument = gql`
  mutation signout {
    signout(input: {}) {
      result
    }
  }
`;
export type SignoutMutationFn = Apollo.MutationFunction<
  SignoutMutation,
  SignoutMutationVariables
>;

/**
 * __useSignoutMutation__
 *
 * To run a mutation, you first call `useSignoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signoutMutation, { data, loading, error }] = useSignoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignoutMutation,
    SignoutMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SignoutMutation, SignoutMutationVariables>(
    SignoutDocument,
    options,
  );
}
export type SignoutMutationHookResult = ReturnType<typeof useSignoutMutation>;
export type SignoutMutationResult = Apollo.MutationResult<SignoutMutation>;
export type SignoutMutationOptions = Apollo.BaseMutationOptions<
  SignoutMutation,
  SignoutMutationVariables
>;
export const SignupDocument = gql`
  mutation signup($user: UserInputType!, $password: PasswordAttributes!) {
    signup(input: {userAttributes: $user, password: $password}) {
      user {
        id
      }
      error
    }
  }
`;
export type SignupMutationFn = Apollo.MutationFunction<
  SignupMutation,
  SignupMutationVariables
>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      user: // value for 'user'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignupMutation,
    SignupMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SignupMutation, SignupMutationVariables>(
    SignupDocument,
    options,
  );
}
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<
  SignupMutation,
  SignupMutationVariables
>;
export const VerifyOtpDocument = gql`
  mutation verifyOtp($code: String!) {
    verifyOtp(input: {code: $code}) {
      user {
        ...userFragment
      }
      remainingAttempts
      error
    }
  }
  ${UserFragmentFragmentDoc}
`;
export type VerifyOtpMutationFn = Apollo.MutationFunction<
  VerifyOtpMutation,
  VerifyOtpMutationVariables
>;

/**
 * __useVerifyOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpMutation, { data, loading, error }] = useVerifyOtpMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyOtpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyOtpMutation,
    VerifyOtpMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<VerifyOtpMutation, VerifyOtpMutationVariables>(
    VerifyOtpDocument,
    options,
  );
}
export type VerifyOtpMutationHookResult = ReturnType<
  typeof useVerifyOtpMutation
>;
export type VerifyOtpMutationResult = Apollo.MutationResult<VerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<
  VerifyOtpMutation,
  VerifyOtpMutationVariables
>;
export const UpdateBankDocument = gql`
  mutation updateBank($bank: BankInputType!) {
    updateBank(input: {bank: $bank}) {
      bank {
        ...bankFragment
      }
    }
  }
  ${BankFragmentFragmentDoc}
`;
export type UpdateBankMutationFn = Apollo.MutationFunction<
  UpdateBankMutation,
  UpdateBankMutationVariables
>;

/**
 * __useUpdateBankMutation__
 *
 * To run a mutation, you first call `useUpdateBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankMutation, { data, loading, error }] = useUpdateBankMutation({
 *   variables: {
 *      bank: // value for 'bank'
 *   },
 * });
 */
export function useUpdateBankMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBankMutation,
    UpdateBankMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateBankMutation, UpdateBankMutationVariables>(
    UpdateBankDocument,
    options,
  );
}
export type UpdateBankMutationHookResult = ReturnType<
  typeof useUpdateBankMutation
>;
export type UpdateBankMutationResult =
  Apollo.MutationResult<UpdateBankMutation>;
export type UpdateBankMutationOptions = Apollo.BaseMutationOptions<
  UpdateBankMutation,
  UpdateBankMutationVariables
>;
export const AddressDocument = gql`
  mutation address($id: ID!, $address: AddressInputType!) {
    address(input: {id: $id, address: $address}) {
      error
      order {
        id
        user {
          ...userFragment
          address {
            ...addressFragment
            industryType {
              id
            }
          }
        }
      }
    }
  }
  ${UserFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
`;
export type AddressMutationFn = Apollo.MutationFunction<
  AddressMutation,
  AddressMutationVariables
>;

/**
 * __useAddressMutation__
 *
 * To run a mutation, you first call `useAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressMutation, { data, loading, error }] = useAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddressMutation,
    AddressMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<AddressMutation, AddressMutationVariables>(
    AddressDocument,
    options,
  );
}
export type AddressMutationHookResult = ReturnType<typeof useAddressMutation>;
export type AddressMutationResult = Apollo.MutationResult<AddressMutation>;
export type AddressMutationOptions = Apollo.BaseMutationOptions<
  AddressMutation,
  AddressMutationVariables
>;
export const CreatePayjpCustomerDocument = gql`
  mutation createPayjpCustomer($attributes: PayjpCustomerAttributes!) {
    createPayjpCustomer(input: {attributes: $attributes}) {
      payjpCustomer {
        ...payjpCustomerFragment
        card {
          ...payjpCardFragment
        }
      }
    }
  }
  ${PayjpCustomerFragmentFragmentDoc}
  ${PayjpCardFragmentFragmentDoc}
`;
export type CreatePayjpCustomerMutationFn = Apollo.MutationFunction<
  CreatePayjpCustomerMutation,
  CreatePayjpCustomerMutationVariables
>;

/**
 * __useCreatePayjpCustomerMutation__
 *
 * To run a mutation, you first call `useCreatePayjpCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayjpCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayjpCustomerMutation, { data, loading, error }] = useCreatePayjpCustomerMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreatePayjpCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePayjpCustomerMutation,
    CreatePayjpCustomerMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreatePayjpCustomerMutation,
    CreatePayjpCustomerMutationVariables
  >(CreatePayjpCustomerDocument, options);
}
export type CreatePayjpCustomerMutationHookResult = ReturnType<
  typeof useCreatePayjpCustomerMutation
>;
export type CreatePayjpCustomerMutationResult =
  Apollo.MutationResult<CreatePayjpCustomerMutation>;
export type CreatePayjpCustomerMutationOptions = Apollo.BaseMutationOptions<
  CreatePayjpCustomerMutation,
  CreatePayjpCustomerMutationVariables
>;
export const OrderDocument = gql`
  mutation order($id: ID!) {
    order(input: {id: $id}) {
      order {
        ...orderFragment
      }
      error
      tdsRequired
    }
  }
  ${OrderFragmentFragmentDoc}
`;
export type OrderMutationFn = Apollo.MutationFunction<
  OrderMutation,
  OrderMutationVariables
>;

/**
 * __useOrderMutation__
 *
 * To run a mutation, you first call `useOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderMutation, { data, loading, error }] = useOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrderMutation,
    OrderMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<OrderMutation, OrderMutationVariables>(
    OrderDocument,
    options,
  );
}
export type OrderMutationHookResult = ReturnType<typeof useOrderMutation>;
export type OrderMutationResult = Apollo.MutationResult<OrderMutation>;
export type OrderMutationOptions = Apollo.BaseMutationOptions<
  OrderMutation,
  OrderMutationVariables
>;
export const PaymentDocument = gql`
  mutation payment($id: ID!) {
    payment(input: {id: $id}) {
      error
      order {
        ...orderFragment
      }
    }
  }
  ${OrderFragmentFragmentDoc}
`;
export type PaymentMutationFn = Apollo.MutationFunction<
  PaymentMutation,
  PaymentMutationVariables
>;

/**
 * __usePaymentMutation__
 *
 * To run a mutation, you first call `usePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMutation, { data, loading, error }] = usePaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentMutation,
    PaymentMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<PaymentMutation, PaymentMutationVariables>(
    PaymentDocument,
    options,
  );
}
export type PaymentMutationHookResult = ReturnType<typeof usePaymentMutation>;
export type PaymentMutationResult = Apollo.MutationResult<PaymentMutation>;
export type PaymentMutationOptions = Apollo.BaseMutationOptions<
  PaymentMutation,
  PaymentMutationVariables
>;
export const TdsFinishOrderDocument = gql`
  mutation tdsFinishOrder($orderId: ID!) {
    tdsFinishOrder(input: {orderId: $orderId}) {
      order {
        ...orderFragment
      }
      error
    }
  }
  ${OrderFragmentFragmentDoc}
`;
export type TdsFinishOrderMutationFn = Apollo.MutationFunction<
  TdsFinishOrderMutation,
  TdsFinishOrderMutationVariables
>;

/**
 * __useTdsFinishOrderMutation__
 *
 * To run a mutation, you first call `useTdsFinishOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTdsFinishOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tdsFinishOrderMutation, { data, loading, error }] = useTdsFinishOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useTdsFinishOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TdsFinishOrderMutation,
    TdsFinishOrderMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    TdsFinishOrderMutation,
    TdsFinishOrderMutationVariables
  >(TdsFinishOrderDocument, options);
}
export type TdsFinishOrderMutationHookResult = ReturnType<
  typeof useTdsFinishOrderMutation
>;
export type TdsFinishOrderMutationResult =
  Apollo.MutationResult<TdsFinishOrderMutation>;
export type TdsFinishOrderMutationOptions = Apollo.BaseMutationOptions<
  TdsFinishOrderMutation,
  TdsFinishOrderMutationVariables
>;
export const UpdatePayjpCustomerDocument = gql`
  mutation updatePayjpCustomer(
    $id: ID!
    $attributes: PayjpCustomerAttributes!
  ) {
    updatePayjpCustomer(input: {id: $id, attributes: $attributes}) {
      payjpCustomer {
        ...payjpCustomerFragment
        card {
          ...payjpCardFragment
        }
      }
    }
  }
  ${PayjpCustomerFragmentFragmentDoc}
  ${PayjpCardFragmentFragmentDoc}
`;
export type UpdatePayjpCustomerMutationFn = Apollo.MutationFunction<
  UpdatePayjpCustomerMutation,
  UpdatePayjpCustomerMutationVariables
>;

/**
 * __useUpdatePayjpCustomerMutation__
 *
 * To run a mutation, you first call `useUpdatePayjpCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayjpCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayjpCustomerMutation, { data, loading, error }] = useUpdatePayjpCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePayjpCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePayjpCustomerMutation,
    UpdatePayjpCustomerMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdatePayjpCustomerMutation,
    UpdatePayjpCustomerMutationVariables
  >(UpdatePayjpCustomerDocument, options);
}
export type UpdatePayjpCustomerMutationHookResult = ReturnType<
  typeof useUpdatePayjpCustomerMutation
>;
export type UpdatePayjpCustomerMutationResult =
  Apollo.MutationResult<UpdatePayjpCustomerMutation>;
export type UpdatePayjpCustomerMutationOptions = Apollo.BaseMutationOptions<
  UpdatePayjpCustomerMutation,
  UpdatePayjpCustomerMutationVariables
>;
export const CreateContactDocument = gql`
  mutation createContact($attributes: ContactAttributes!) {
    createContact(input: {attributes: $attributes}) {
      contact {
        ...contactFragment
      }
      error
    }
  }
  ${ContactFragmentFragmentDoc}
`;
export type CreateContactMutationFn = Apollo.MutationFunction<
  CreateContactMutation,
  CreateContactMutationVariables
>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContactMutation,
    CreateContactMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreateContactMutation,
    CreateContactMutationVariables
  >(CreateContactDocument, options);
}
export type CreateContactMutationHookResult = ReturnType<
  typeof useCreateContactMutation
>;
export type CreateContactMutationResult =
  Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<
  CreateContactMutation,
  CreateContactMutationVariables
>;
export const RefreshDoorLockDocument = gql`
  mutation refreshDoorLock($target: String!) {
    refreshDoorLock(input: {target: $target}) {
      error
      doorLock {
        target
        targetName
        batteryPercentage
        lockStatus
        fetchedAt
        lowBattery
        lowBatteryThreshold
      }
    }
  }
`;
export type RefreshDoorLockMutationFn = Apollo.MutationFunction<
  RefreshDoorLockMutation,
  RefreshDoorLockMutationVariables
>;

/**
 * __useRefreshDoorLockMutation__
 *
 * To run a mutation, you first call `useRefreshDoorLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshDoorLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshDoorLockMutation, { data, loading, error }] = useRefreshDoorLockMutation({
 *   variables: {
 *      target: // value for 'target'
 *   },
 * });
 */
export function useRefreshDoorLockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshDoorLockMutation,
    RefreshDoorLockMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    RefreshDoorLockMutation,
    RefreshDoorLockMutationVariables
  >(RefreshDoorLockDocument, options);
}
export type RefreshDoorLockMutationHookResult = ReturnType<
  typeof useRefreshDoorLockMutation
>;
export type RefreshDoorLockMutationResult =
  Apollo.MutationResult<RefreshDoorLockMutation>;
export type RefreshDoorLockMutationOptions = Apollo.BaseMutationOptions<
  RefreshDoorLockMutation,
  RefreshDoorLockMutationVariables
>;
export const ReissueDoorKeyDocument = gql`
  mutation reissueDoorKey($input: ReissueDoorKeyInput!) {
    reissueDoorKey(input: $input) {
      message
      error
      doorKey {
        ...adminDoorKeyFragment
      }
    }
  }
  ${AdminDoorKeyFragmentFragmentDoc}
`;
export type ReissueDoorKeyMutationFn = Apollo.MutationFunction<
  ReissueDoorKeyMutation,
  ReissueDoorKeyMutationVariables
>;

/**
 * __useReissueDoorKeyMutation__
 *
 * To run a mutation, you first call `useReissueDoorKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReissueDoorKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reissueDoorKeyMutation, { data, loading, error }] = useReissueDoorKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReissueDoorKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReissueDoorKeyMutation,
    ReissueDoorKeyMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ReissueDoorKeyMutation,
    ReissueDoorKeyMutationVariables
  >(ReissueDoorKeyDocument, options);
}
export type ReissueDoorKeyMutationHookResult = ReturnType<
  typeof useReissueDoorKeyMutation
>;
export type ReissueDoorKeyMutationResult =
  Apollo.MutationResult<ReissueDoorKeyMutation>;
export type ReissueDoorKeyMutationOptions = Apollo.BaseMutationOptions<
  ReissueDoorKeyMutation,
  ReissueDoorKeyMutationVariables
>;
export const RemoteUnlockDoorDocument = gql`
  mutation remoteUnlockDoor($input: RemoteUnlockDoorInput!) {
    remoteUnlockDoor(input: $input) {
      message
      error
      doorKey {
        ...adminDoorKeyFragment
      }
    }
  }
  ${AdminDoorKeyFragmentFragmentDoc}
`;
export type RemoteUnlockDoorMutationFn = Apollo.MutationFunction<
  RemoteUnlockDoorMutation,
  RemoteUnlockDoorMutationVariables
>;

/**
 * __useRemoteUnlockDoorMutation__
 *
 * To run a mutation, you first call `useRemoteUnlockDoorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoteUnlockDoorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remoteUnlockDoorMutation, { data, loading, error }] = useRemoteUnlockDoorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoteUnlockDoorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoteUnlockDoorMutation,
    RemoteUnlockDoorMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    RemoteUnlockDoorMutation,
    RemoteUnlockDoorMutationVariables
  >(RemoteUnlockDoorDocument, options);
}
export type RemoteUnlockDoorMutationHookResult = ReturnType<
  typeof useRemoteUnlockDoorMutation
>;
export type RemoteUnlockDoorMutationResult =
  Apollo.MutationResult<RemoteUnlockDoorMutation>;
export type RemoteUnlockDoorMutationOptions = Apollo.BaseMutationOptions<
  RemoteUnlockDoorMutation,
  RemoteUnlockDoorMutationVariables
>;
export const ResendDoorKeyMailDocument = gql`
  mutation resendDoorKeyMail($input: ResendDoorKeyMailInput!) {
    resendDoorKeyMail(input: $input) {
      message
      error
      doorKey {
        ...adminDoorKeyFragment
      }
    }
  }
  ${AdminDoorKeyFragmentFragmentDoc}
`;
export type ResendDoorKeyMailMutationFn = Apollo.MutationFunction<
  ResendDoorKeyMailMutation,
  ResendDoorKeyMailMutationVariables
>;

/**
 * __useResendDoorKeyMailMutation__
 *
 * To run a mutation, you first call `useResendDoorKeyMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendDoorKeyMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendDoorKeyMailMutation, { data, loading, error }] = useResendDoorKeyMailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendDoorKeyMailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendDoorKeyMailMutation,
    ResendDoorKeyMailMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ResendDoorKeyMailMutation,
    ResendDoorKeyMailMutationVariables
  >(ResendDoorKeyMailDocument, options);
}
export type ResendDoorKeyMailMutationHookResult = ReturnType<
  typeof useResendDoorKeyMailMutation
>;
export type ResendDoorKeyMailMutationResult =
  Apollo.MutationResult<ResendDoorKeyMailMutation>;
export type ResendDoorKeyMailMutationOptions = Apollo.BaseMutationOptions<
  ResendDoorKeyMailMutation,
  ResendDoorKeyMailMutationVariables
>;
export const RevokeDoorKeyDocument = gql`
  mutation revokeDoorKey($input: RevokeDoorKeyInput!) {
    revokeDoorKey(input: $input) {
      message
      error
      doorKey {
        ...adminDoorKeyFragment
      }
    }
  }
  ${AdminDoorKeyFragmentFragmentDoc}
`;
export type RevokeDoorKeyMutationFn = Apollo.MutationFunction<
  RevokeDoorKeyMutation,
  RevokeDoorKeyMutationVariables
>;

/**
 * __useRevokeDoorKeyMutation__
 *
 * To run a mutation, you first call `useRevokeDoorKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeDoorKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeDoorKeyMutation, { data, loading, error }] = useRevokeDoorKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeDoorKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeDoorKeyMutation,
    RevokeDoorKeyMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    RevokeDoorKeyMutation,
    RevokeDoorKeyMutationVariables
  >(RevokeDoorKeyDocument, options);
}
export type RevokeDoorKeyMutationHookResult = ReturnType<
  typeof useRevokeDoorKeyMutation
>;
export type RevokeDoorKeyMutationResult =
  Apollo.MutationResult<RevokeDoorKeyMutation>;
export type RevokeDoorKeyMutationOptions = Apollo.BaseMutationOptions<
  RevokeDoorKeyMutation,
  RevokeDoorKeyMutationVariables
>;
export const UnlockDoorKeyDocument = gql`
  mutation unlockDoorKey($token: String!) {
    unlockDoorKey(input: {token: $token}) {
      result
      message
      doorKey {
        ...publicDoorKeyFragment
      }
    }
  }
  ${PublicDoorKeyFragmentFragmentDoc}
`;
export type UnlockDoorKeyMutationFn = Apollo.MutationFunction<
  UnlockDoorKeyMutation,
  UnlockDoorKeyMutationVariables
>;

/**
 * __useUnlockDoorKeyMutation__
 *
 * To run a mutation, you first call `useUnlockDoorKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockDoorKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockDoorKeyMutation, { data, loading, error }] = useUnlockDoorKeyMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUnlockDoorKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnlockDoorKeyMutation,
    UnlockDoorKeyMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UnlockDoorKeyMutation,
    UnlockDoorKeyMutationVariables
  >(UnlockDoorKeyDocument, options);
}
export type UnlockDoorKeyMutationHookResult = ReturnType<
  typeof useUnlockDoorKeyMutation
>;
export type UnlockDoorKeyMutationResult =
  Apollo.MutationResult<UnlockDoorKeyMutation>;
export type UnlockDoorKeyMutationOptions = Apollo.BaseMutationOptions<
  UnlockDoorKeyMutation,
  UnlockDoorKeyMutationVariables
>;
export const AcceptEventDocument = gql`
  mutation acceptEvent($id: ID!, $event: EventInputType!) {
    acceptEvent(input: {id: $id, event: $event}) {
      event {
        ...eventFragment
      }
      error
    }
  }
  ${EventFragmentFragmentDoc}
`;
export type AcceptEventMutationFn = Apollo.MutationFunction<
  AcceptEventMutation,
  AcceptEventMutationVariables
>;

/**
 * __useAcceptEventMutation__
 *
 * To run a mutation, you first call `useAcceptEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptEventMutation, { data, loading, error }] = useAcceptEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useAcceptEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptEventMutation,
    AcceptEventMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<AcceptEventMutation, AcceptEventMutationVariables>(
    AcceptEventDocument,
    options,
  );
}
export type AcceptEventMutationHookResult = ReturnType<
  typeof useAcceptEventMutation
>;
export type AcceptEventMutationResult =
  Apollo.MutationResult<AcceptEventMutation>;
export type AcceptEventMutationOptions = Apollo.BaseMutationOptions<
  AcceptEventMutation,
  AcceptEventMutationVariables
>;
export const ApplyCouponToEventDocument = gql`
  mutation applyCouponToEvent($id: ID!, $coupon: String!) {
    applyCouponToEvent(input: {id: $id, coupon: $coupon}) {
      event {
        ...eventFragment
      }
      error
    }
  }
  ${EventFragmentFragmentDoc}
`;
export type ApplyCouponToEventMutationFn = Apollo.MutationFunction<
  ApplyCouponToEventMutation,
  ApplyCouponToEventMutationVariables
>;

/**
 * __useApplyCouponToEventMutation__
 *
 * To run a mutation, you first call `useApplyCouponToEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCouponToEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCouponToEventMutation, { data, loading, error }] = useApplyCouponToEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      coupon: // value for 'coupon'
 *   },
 * });
 */
export function useApplyCouponToEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyCouponToEventMutation,
    ApplyCouponToEventMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ApplyCouponToEventMutation,
    ApplyCouponToEventMutationVariables
  >(ApplyCouponToEventDocument, options);
}
export type ApplyCouponToEventMutationHookResult = ReturnType<
  typeof useApplyCouponToEventMutation
>;
export type ApplyCouponToEventMutationResult =
  Apollo.MutationResult<ApplyCouponToEventMutation>;
export type ApplyCouponToEventMutationOptions = Apollo.BaseMutationOptions<
  ApplyCouponToEventMutation,
  ApplyCouponToEventMutationVariables
>;
export const ApplyEventDocument = gql`
  mutation applyEvent($id: ID!, $event: EventInputType!) {
    applyEvent(input: {id: $id, event: $event}) {
      event {
        ...eventFragment
      }
      tdsRequired
      error
    }
  }
  ${EventFragmentFragmentDoc}
`;
export type ApplyEventMutationFn = Apollo.MutationFunction<
  ApplyEventMutation,
  ApplyEventMutationVariables
>;

/**
 * __useApplyEventMutation__
 *
 * To run a mutation, you first call `useApplyEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyEventMutation, { data, loading, error }] = useApplyEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useApplyEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyEventMutation,
    ApplyEventMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ApplyEventMutation, ApplyEventMutationVariables>(
    ApplyEventDocument,
    options,
  );
}
export type ApplyEventMutationHookResult = ReturnType<
  typeof useApplyEventMutation
>;
export type ApplyEventMutationResult =
  Apollo.MutationResult<ApplyEventMutation>;
export type ApplyEventMutationOptions = Apollo.BaseMutationOptions<
  ApplyEventMutation,
  ApplyEventMutationVariables
>;
export const CreateEventDocument = gql`
  mutation createEvent($event: EventInputType!) {
    createEvent(input: {event: $event}) {
      event {
        ...eventFragment
      }
    }
  }
  ${EventFragmentFragmentDoc}
`;
export type CreateEventMutationFn = Apollo.MutationFunction<
  CreateEventMutation,
  CreateEventMutationVariables
>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useCreateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEventMutation,
    CreateEventMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(
    CreateEventDocument,
    options,
  );
}
export type CreateEventMutationHookResult = ReturnType<
  typeof useCreateEventMutation
>;
export type CreateEventMutationResult =
  Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<
  CreateEventMutation,
  CreateEventMutationVariables
>;
export const RejectEventDocument = gql`
  mutation rejectEvent($id: ID!, $event: EventInputType!) {
    rejectEvent(input: {id: $id, event: $event}) {
      event {
        ...eventFragment
      }
    }
  }
  ${EventFragmentFragmentDoc}
`;
export type RejectEventMutationFn = Apollo.MutationFunction<
  RejectEventMutation,
  RejectEventMutationVariables
>;

/**
 * __useRejectEventMutation__
 *
 * To run a mutation, you first call `useRejectEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectEventMutation, { data, loading, error }] = useRejectEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useRejectEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RejectEventMutation,
    RejectEventMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<RejectEventMutation, RejectEventMutationVariables>(
    RejectEventDocument,
    options,
  );
}
export type RejectEventMutationHookResult = ReturnType<
  typeof useRejectEventMutation
>;
export type RejectEventMutationResult =
  Apollo.MutationResult<RejectEventMutation>;
export type RejectEventMutationOptions = Apollo.BaseMutationOptions<
  RejectEventMutation,
  RejectEventMutationVariables
>;
export const RemoveEventDocument = gql`
  mutation removeEvent($id: ID!) {
    removeEvent(input: {id: $id}) {
      event {
        ...eventFragment
      }
    }
  }
  ${EventFragmentFragmentDoc}
`;
export type RemoveEventMutationFn = Apollo.MutationFunction<
  RemoveEventMutation,
  RemoveEventMutationVariables
>;

/**
 * __useRemoveEventMutation__
 *
 * To run a mutation, you first call `useRemoveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventMutation, { data, loading, error }] = useRemoveEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveEventMutation,
    RemoveEventMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<RemoveEventMutation, RemoveEventMutationVariables>(
    RemoveEventDocument,
    options,
  );
}
export type RemoveEventMutationHookResult = ReturnType<
  typeof useRemoveEventMutation
>;
export type RemoveEventMutationResult =
  Apollo.MutationResult<RemoveEventMutation>;
export type RemoveEventMutationOptions = Apollo.BaseMutationOptions<
  RemoveEventMutation,
  RemoveEventMutationVariables
>;
export const RevertEventDocument = gql`
  mutation revertEvent($id: ID!) {
    revertEvent(input: {id: $id}) {
      event {
        ...eventFragment
      }
    }
  }
  ${EventFragmentFragmentDoc}
`;
export type RevertEventMutationFn = Apollo.MutationFunction<
  RevertEventMutation,
  RevertEventMutationVariables
>;

/**
 * __useRevertEventMutation__
 *
 * To run a mutation, you first call `useRevertEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertEventMutation, { data, loading, error }] = useRevertEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevertEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevertEventMutation,
    RevertEventMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<RevertEventMutation, RevertEventMutationVariables>(
    RevertEventDocument,
    options,
  );
}
export type RevertEventMutationHookResult = ReturnType<
  typeof useRevertEventMutation
>;
export type RevertEventMutationResult =
  Apollo.MutationResult<RevertEventMutation>;
export type RevertEventMutationOptions = Apollo.BaseMutationOptions<
  RevertEventMutation,
  RevertEventMutationVariables
>;
export const TdsFinishEventDocument = gql`
  mutation tdsFinishEvent($eventId: ID!) {
    tdsFinishEvent(input: {eventId: $eventId}) {
      event {
        ...eventFragment
      }
      error
    }
  }
  ${EventFragmentFragmentDoc}
`;
export type TdsFinishEventMutationFn = Apollo.MutationFunction<
  TdsFinishEventMutation,
  TdsFinishEventMutationVariables
>;

/**
 * __useTdsFinishEventMutation__
 *
 * To run a mutation, you first call `useTdsFinishEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTdsFinishEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tdsFinishEventMutation, { data, loading, error }] = useTdsFinishEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useTdsFinishEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TdsFinishEventMutation,
    TdsFinishEventMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    TdsFinishEventMutation,
    TdsFinishEventMutationVariables
  >(TdsFinishEventDocument, options);
}
export type TdsFinishEventMutationHookResult = ReturnType<
  typeof useTdsFinishEventMutation
>;
export type TdsFinishEventMutationResult =
  Apollo.MutationResult<TdsFinishEventMutation>;
export type TdsFinishEventMutationOptions = Apollo.BaseMutationOptions<
  TdsFinishEventMutation,
  TdsFinishEventMutationVariables
>;
export const UpdateEventDocument = gql`
  mutation updateEvent($id: ID!, $event: EventInputType, $file: File) {
    updateEvent(input: {id: $id, event: $event, file: $file}) {
      event {
        ...eventFragment
      }
    }
  }
  ${EventFragmentFragmentDoc}
`;
export type UpdateEventMutationFn = Apollo.MutationFunction<
  UpdateEventMutation,
  UpdateEventMutationVariables
>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      event: // value for 'event'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEventMutation,
    UpdateEventMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(
    UpdateEventDocument,
    options,
  );
}
export type UpdateEventMutationHookResult = ReturnType<
  typeof useUpdateEventMutation
>;
export type UpdateEventMutationResult =
  Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<
  UpdateEventMutation,
  UpdateEventMutationVariables
>;
export const UpdateEventOptionDocument = gql`
  mutation updateEventOption($id: ID!, $eventOption: EventOptionInputType!) {
    updateEventOption(input: {id: $id, eventOption: $eventOption}) {
      eventOption {
        ...eventOptionFragment
      }
    }
  }
  ${EventOptionFragmentFragmentDoc}
`;
export type UpdateEventOptionMutationFn = Apollo.MutationFunction<
  UpdateEventOptionMutation,
  UpdateEventOptionMutationVariables
>;

/**
 * __useUpdateEventOptionMutation__
 *
 * To run a mutation, you first call `useUpdateEventOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventOptionMutation, { data, loading, error }] = useUpdateEventOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      eventOption: // value for 'eventOption'
 *   },
 * });
 */
export function useUpdateEventOptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEventOptionMutation,
    UpdateEventOptionMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdateEventOptionMutation,
    UpdateEventOptionMutationVariables
  >(UpdateEventOptionDocument, options);
}
export type UpdateEventOptionMutationHookResult = ReturnType<
  typeof useUpdateEventOptionMutation
>;
export type UpdateEventOptionMutationResult =
  Apollo.MutationResult<UpdateEventOptionMutation>;
export type UpdateEventOptionMutationOptions = Apollo.BaseMutationOptions<
  UpdateEventOptionMutation,
  UpdateEventOptionMutationVariables
>;
export const CreateEventScheduleDocument = gql`
  mutation createEventSchedule($eventSchedule: EventScheduleInputType!) {
    createEventSchedule(input: {eventSchedule: $eventSchedule}) {
      event {
        ...eventFragment
        eventSchedules {
          ...eventScheduleFragment
        }
      }
    }
  }
  ${EventFragmentFragmentDoc}
  ${EventScheduleFragmentFragmentDoc}
`;
export type CreateEventScheduleMutationFn = Apollo.MutationFunction<
  CreateEventScheduleMutation,
  CreateEventScheduleMutationVariables
>;

/**
 * __useCreateEventScheduleMutation__
 *
 * To run a mutation, you first call `useCreateEventScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventScheduleMutation, { data, loading, error }] = useCreateEventScheduleMutation({
 *   variables: {
 *      eventSchedule: // value for 'eventSchedule'
 *   },
 * });
 */
export function useCreateEventScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEventScheduleMutation,
    CreateEventScheduleMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreateEventScheduleMutation,
    CreateEventScheduleMutationVariables
  >(CreateEventScheduleDocument, options);
}
export type CreateEventScheduleMutationHookResult = ReturnType<
  typeof useCreateEventScheduleMutation
>;
export type CreateEventScheduleMutationResult =
  Apollo.MutationResult<CreateEventScheduleMutation>;
export type CreateEventScheduleMutationOptions = Apollo.BaseMutationOptions<
  CreateEventScheduleMutation,
  CreateEventScheduleMutationVariables
>;
export const RemoveEventScheduleDocument = gql`
  mutation removeEventSchedule($id: ID!) {
    removeEventSchedule(input: {id: $id}) {
      event {
        ...eventFragment
        eventSchedules {
          ...eventScheduleFragment
        }
      }
    }
  }
  ${EventFragmentFragmentDoc}
  ${EventScheduleFragmentFragmentDoc}
`;
export type RemoveEventScheduleMutationFn = Apollo.MutationFunction<
  RemoveEventScheduleMutation,
  RemoveEventScheduleMutationVariables
>;

/**
 * __useRemoveEventScheduleMutation__
 *
 * To run a mutation, you first call `useRemoveEventScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventScheduleMutation, { data, loading, error }] = useRemoveEventScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEventScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveEventScheduleMutation,
    RemoveEventScheduleMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    RemoveEventScheduleMutation,
    RemoveEventScheduleMutationVariables
  >(RemoveEventScheduleDocument, options);
}
export type RemoveEventScheduleMutationHookResult = ReturnType<
  typeof useRemoveEventScheduleMutation
>;
export type RemoveEventScheduleMutationResult =
  Apollo.MutationResult<RemoveEventScheduleMutation>;
export type RemoveEventScheduleMutationOptions = Apollo.BaseMutationOptions<
  RemoveEventScheduleMutation,
  RemoveEventScheduleMutationVariables
>;
export const UpdateEventScheduleDocument = gql`
  mutation updateEventSchedule(
    $id: ID!
    $eventSchedule: EventScheduleInputType!
  ) {
    updateEventSchedule(input: {id: $id, eventSchedule: $eventSchedule}) {
      event {
        ...eventFragment
        eventSchedules {
          ...eventScheduleFragment
        }
      }
    }
  }
  ${EventFragmentFragmentDoc}
  ${EventScheduleFragmentFragmentDoc}
`;
export type UpdateEventScheduleMutationFn = Apollo.MutationFunction<
  UpdateEventScheduleMutation,
  UpdateEventScheduleMutationVariables
>;

/**
 * __useUpdateEventScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateEventScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventScheduleMutation, { data, loading, error }] = useUpdateEventScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      eventSchedule: // value for 'eventSchedule'
 *   },
 * });
 */
export function useUpdateEventScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEventScheduleMutation,
    UpdateEventScheduleMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdateEventScheduleMutation,
    UpdateEventScheduleMutationVariables
  >(UpdateEventScheduleDocument, options);
}
export type UpdateEventScheduleMutationHookResult = ReturnType<
  typeof useUpdateEventScheduleMutation
>;
export type UpdateEventScheduleMutationResult =
  Apollo.MutationResult<UpdateEventScheduleMutation>;
export type UpdateEventScheduleMutationOptions = Apollo.BaseMutationOptions<
  UpdateEventScheduleMutation,
  UpdateEventScheduleMutationVariables
>;
export const AcceptRequestDocument = gql`
  mutation acceptRequest($id: ID!) {
    acceptRequest(input: {id: $id}) {
      request {
        id
        groupId
        userId
        status
      }
    }
  }
`;
export type AcceptRequestMutationFn = Apollo.MutationFunction<
  AcceptRequestMutation,
  AcceptRequestMutationVariables
>;

/**
 * __useAcceptRequestMutation__
 *
 * To run a mutation, you first call `useAcceptRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptRequestMutation, { data, loading, error }] = useAcceptRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptRequestMutation,
    AcceptRequestMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    AcceptRequestMutation,
    AcceptRequestMutationVariables
  >(AcceptRequestDocument, options);
}
export type AcceptRequestMutationHookResult = ReturnType<
  typeof useAcceptRequestMutation
>;
export type AcceptRequestMutationResult =
  Apollo.MutationResult<AcceptRequestMutation>;
export type AcceptRequestMutationOptions = Apollo.BaseMutationOptions<
  AcceptRequestMutation,
  AcceptRequestMutationVariables
>;
export const AddGroupActivityDocument = gql`
  mutation addGroupActivity($attributes: GroupActivityAttributes!) {
    addGroupActivity(input: {attributes: $attributes}) {
      group {
        id
        isAdmin
        name
        activities {
          id
          groupId
          userId
          title
          comments {
            id
            groupActivityId
            userId
            message
            createdAtText
            isEdit
            isRemove
            user {
              id
              fullName
            }
          }
        }
      }
    }
  }
`;
export type AddGroupActivityMutationFn = Apollo.MutationFunction<
  AddGroupActivityMutation,
  AddGroupActivityMutationVariables
>;

/**
 * __useAddGroupActivityMutation__
 *
 * To run a mutation, you first call `useAddGroupActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGroupActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGroupActivityMutation, { data, loading, error }] = useAddGroupActivityMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddGroupActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddGroupActivityMutation,
    AddGroupActivityMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    AddGroupActivityMutation,
    AddGroupActivityMutationVariables
  >(AddGroupActivityDocument, options);
}
export type AddGroupActivityMutationHookResult = ReturnType<
  typeof useAddGroupActivityMutation
>;
export type AddGroupActivityMutationResult =
  Apollo.MutationResult<AddGroupActivityMutation>;
export type AddGroupActivityMutationOptions = Apollo.BaseMutationOptions<
  AddGroupActivityMutation,
  AddGroupActivityMutationVariables
>;
export const AddGroupCommentDocument = gql`
  mutation addGroupComment($id: ID!, $attributes: CommentInputType!) {
    addGroupComment(input: {id: $id, attributes: $attributes}) {
      comment {
        id
        groupActivityId
        userId
        message
        createdAtText
        isEdit
        isRemove
        user {
          id
          fullName
        }
      }
    }
  }
`;
export type AddGroupCommentMutationFn = Apollo.MutationFunction<
  AddGroupCommentMutation,
  AddGroupCommentMutationVariables
>;

/**
 * __useAddGroupCommentMutation__
 *
 * To run a mutation, you first call `useAddGroupCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGroupCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGroupCommentMutation, { data, loading, error }] = useAddGroupCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddGroupCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddGroupCommentMutation,
    AddGroupCommentMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    AddGroupCommentMutation,
    AddGroupCommentMutationVariables
  >(AddGroupCommentDocument, options);
}
export type AddGroupCommentMutationHookResult = ReturnType<
  typeof useAddGroupCommentMutation
>;
export type AddGroupCommentMutationResult =
  Apollo.MutationResult<AddGroupCommentMutation>;
export type AddGroupCommentMutationOptions = Apollo.BaseMutationOptions<
  AddGroupCommentMutation,
  AddGroupCommentMutationVariables
>;
export const CreateGroupDocument = gql`
  mutation createGroup($group: GroupInputType!) {
    createGroup(input: {group: $group}) {
      group {
        ...groupFragment
      }
    }
  }
  ${GroupFragmentFragmentDoc}
`;
export type CreateGroupMutationFn = Apollo.MutationFunction<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      group: // value for 'group'
 *   },
 * });
 */
export function useCreateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGroupMutation,
    CreateGroupMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(
    CreateGroupDocument,
    options,
  );
}
export type CreateGroupMutationHookResult = ReturnType<
  typeof useCreateGroupMutation
>;
export type CreateGroupMutationResult =
  Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;
export const CreateRequestDocument = gql`
  mutation createRequest($request: RequestInputType!) {
    createRequest(input: {request: $request}) {
      group {
        ...groupFragment
      }
    }
  }
  ${GroupFragmentFragmentDoc}
`;
export type CreateRequestMutationFn = Apollo.MutationFunction<
  CreateRequestMutation,
  CreateRequestMutationVariables
>;

/**
 * __useCreateRequestMutation__
 *
 * To run a mutation, you first call `useCreateRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequestMutation, { data, loading, error }] = useCreateRequestMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreateRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRequestMutation,
    CreateRequestMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreateRequestMutation,
    CreateRequestMutationVariables
  >(CreateRequestDocument, options);
}
export type CreateRequestMutationHookResult = ReturnType<
  typeof useCreateRequestMutation
>;
export type CreateRequestMutationResult =
  Apollo.MutationResult<CreateRequestMutation>;
export type CreateRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateRequestMutation,
  CreateRequestMutationVariables
>;
export const DestroyGroupUserDocument = gql`
  mutation destroyGroupUser($id: ID!) {
    destroyGroupUser(input: {id: $id}) {
      group {
        id
        groupAdmins {
          id
          user {
            id
            email
            fullName
          }
        }
        groupMembers {
          id
          user {
            id
            email
            fullName
          }
        }
      }
    }
  }
`;
export type DestroyGroupUserMutationFn = Apollo.MutationFunction<
  DestroyGroupUserMutation,
  DestroyGroupUserMutationVariables
>;

/**
 * __useDestroyGroupUserMutation__
 *
 * To run a mutation, you first call `useDestroyGroupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyGroupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyGroupUserMutation, { data, loading, error }] = useDestroyGroupUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyGroupUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DestroyGroupUserMutation,
    DestroyGroupUserMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    DestroyGroupUserMutation,
    DestroyGroupUserMutationVariables
  >(DestroyGroupUserDocument, options);
}
export type DestroyGroupUserMutationHookResult = ReturnType<
  typeof useDestroyGroupUserMutation
>;
export type DestroyGroupUserMutationResult =
  Apollo.MutationResult<DestroyGroupUserMutation>;
export type DestroyGroupUserMutationOptions = Apollo.BaseMutationOptions<
  DestroyGroupUserMutation,
  DestroyGroupUserMutationVariables
>;
export const FollowDocument = gql`
  mutation follow($groupId: ID!) {
    follow(input: {groupId: $groupId}) {
      group {
        id
        isFollower
        groupFollowerCount
        followers {
          id
          userId
          groupId
          user {
            id
            fullName
          }
        }
      }
    }
  }
`;
export type FollowMutationFn = Apollo.MutationFunction<
  FollowMutation,
  FollowMutationVariables
>;

/**
 * __useFollowMutation__
 *
 * To run a mutation, you first call `useFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followMutation, { data, loading, error }] = useFollowMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useFollowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FollowMutation,
    FollowMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<FollowMutation, FollowMutationVariables>(
    FollowDocument,
    options,
  );
}
export type FollowMutationHookResult = ReturnType<typeof useFollowMutation>;
export type FollowMutationResult = Apollo.MutationResult<FollowMutation>;
export type FollowMutationOptions = Apollo.BaseMutationOptions<
  FollowMutation,
  FollowMutationVariables
>;
export const RejectRequestDocument = gql`
  mutation rejectRequest($id: ID!) {
    rejectRequest(input: {id: $id}) {
      request {
        id
        groupId
        userId
        status
      }
    }
  }
`;
export type RejectRequestMutationFn = Apollo.MutationFunction<
  RejectRequestMutation,
  RejectRequestMutationVariables
>;

/**
 * __useRejectRequestMutation__
 *
 * To run a mutation, you first call `useRejectRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRequestMutation, { data, loading, error }] = useRejectRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RejectRequestMutation,
    RejectRequestMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    RejectRequestMutation,
    RejectRequestMutationVariables
  >(RejectRequestDocument, options);
}
export type RejectRequestMutationHookResult = ReturnType<
  typeof useRejectRequestMutation
>;
export type RejectRequestMutationResult =
  Apollo.MutationResult<RejectRequestMutation>;
export type RejectRequestMutationOptions = Apollo.BaseMutationOptions<
  RejectRequestMutation,
  RejectRequestMutationVariables
>;
export const RemoveGroupActivityDocument = gql`
  mutation removeGroupActivity($id: ID!) {
    removeGroupActivity(input: {id: $id}) {
      group {
        id
        isAdmin
        name
        activities {
          id
          groupId
          userId
          title
          comments {
            id
            groupActivityId
            userId
            message
            createdAtText
            isEdit
            isRemove
            user {
              id
              fullName
            }
          }
        }
      }
    }
  }
`;
export type RemoveGroupActivityMutationFn = Apollo.MutationFunction<
  RemoveGroupActivityMutation,
  RemoveGroupActivityMutationVariables
>;

/**
 * __useRemoveGroupActivityMutation__
 *
 * To run a mutation, you first call `useRemoveGroupActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupActivityMutation, { data, loading, error }] = useRemoveGroupActivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGroupActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveGroupActivityMutation,
    RemoveGroupActivityMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    RemoveGroupActivityMutation,
    RemoveGroupActivityMutationVariables
  >(RemoveGroupActivityDocument, options);
}
export type RemoveGroupActivityMutationHookResult = ReturnType<
  typeof useRemoveGroupActivityMutation
>;
export type RemoveGroupActivityMutationResult =
  Apollo.MutationResult<RemoveGroupActivityMutation>;
export type RemoveGroupActivityMutationOptions = Apollo.BaseMutationOptions<
  RemoveGroupActivityMutation,
  RemoveGroupActivityMutationVariables
>;
export const RemoveGroupCommentDocument = gql`
  mutation removeGroupComment($id: ID!) {
    removeGroupComment(input: {id: $id}) {
      comment {
        id
        groupActivityId
        userId
        message
        createdAtText
        isEdit
        isRemove
        user {
          id
          fullName
        }
      }
    }
  }
`;
export type RemoveGroupCommentMutationFn = Apollo.MutationFunction<
  RemoveGroupCommentMutation,
  RemoveGroupCommentMutationVariables
>;

/**
 * __useRemoveGroupCommentMutation__
 *
 * To run a mutation, you first call `useRemoveGroupCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupCommentMutation, { data, loading, error }] = useRemoveGroupCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGroupCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveGroupCommentMutation,
    RemoveGroupCommentMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    RemoveGroupCommentMutation,
    RemoveGroupCommentMutationVariables
  >(RemoveGroupCommentDocument, options);
}
export type RemoveGroupCommentMutationHookResult = ReturnType<
  typeof useRemoveGroupCommentMutation
>;
export type RemoveGroupCommentMutationResult =
  Apollo.MutationResult<RemoveGroupCommentMutation>;
export type RemoveGroupCommentMutationOptions = Apollo.BaseMutationOptions<
  RemoveGroupCommentMutation,
  RemoveGroupCommentMutationVariables
>;
export const SendGroupMailDocument = gql`
  mutation sendGroupMail($groupMail: GroupMailInputType!) {
    sendGroupMail(input: {groupMail: $groupMail}) {
      groupMail {
        id
      }
    }
  }
`;
export type SendGroupMailMutationFn = Apollo.MutationFunction<
  SendGroupMailMutation,
  SendGroupMailMutationVariables
>;

/**
 * __useSendGroupMailMutation__
 *
 * To run a mutation, you first call `useSendGroupMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGroupMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGroupMailMutation, { data, loading, error }] = useSendGroupMailMutation({
 *   variables: {
 *      groupMail: // value for 'groupMail'
 *   },
 * });
 */
export function useSendGroupMailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendGroupMailMutation,
    SendGroupMailMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    SendGroupMailMutation,
    SendGroupMailMutationVariables
  >(SendGroupMailDocument, options);
}
export type SendGroupMailMutationHookResult = ReturnType<
  typeof useSendGroupMailMutation
>;
export type SendGroupMailMutationResult =
  Apollo.MutationResult<SendGroupMailMutation>;
export type SendGroupMailMutationOptions = Apollo.BaseMutationOptions<
  SendGroupMailMutation,
  SendGroupMailMutationVariables
>;
export const UnfollowDocument = gql`
  mutation unfollow($groupId: ID!) {
    unfollow(input: {groupId: $groupId}) {
      group {
        id
        isFollower
        groupFollowerCount
        followers {
          id
          userId
          groupId
          user {
            id
            fullName
          }
        }
      }
    }
  }
`;
export type UnfollowMutationFn = Apollo.MutationFunction<
  UnfollowMutation,
  UnfollowMutationVariables
>;

/**
 * __useUnfollowMutation__
 *
 * To run a mutation, you first call `useUnfollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowMutation, { data, loading, error }] = useUnfollowMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useUnfollowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnfollowMutation,
    UnfollowMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UnfollowMutation, UnfollowMutationVariables>(
    UnfollowDocument,
    options,
  );
}
export type UnfollowMutationHookResult = ReturnType<typeof useUnfollowMutation>;
export type UnfollowMutationResult = Apollo.MutationResult<UnfollowMutation>;
export type UnfollowMutationOptions = Apollo.BaseMutationOptions<
  UnfollowMutation,
  UnfollowMutationVariables
>;
export const UpdateGroupDocument = gql`
  mutation updateGroup($id: ID!, $group: GroupInputType!, $file: File) {
    updateGroup(input: {id: $id, group: $group, file: $file}) {
      group {
        ...groupFragment
      }
    }
  }
  ${GroupFragmentFragmentDoc}
`;
export type UpdateGroupMutationFn = Apollo.MutationFunction<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      group: // value for 'group'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateGroupMutation,
    UpdateGroupMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(
    UpdateGroupDocument,
    options,
  );
}
export type UpdateGroupMutationHookResult = ReturnType<
  typeof useUpdateGroupMutation
>;
export type UpdateGroupMutationResult =
  Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;
export const UpdateGroupActivityDocument = gql`
  mutation updateGroupActivity(
    $id: ID!
    $attributes: GroupActivityAttributes!
  ) {
    updateGroupActivity(input: {id: $id, attributes: $attributes}) {
      groupActivity {
        id
        title
      }
    }
  }
`;
export type UpdateGroupActivityMutationFn = Apollo.MutationFunction<
  UpdateGroupActivityMutation,
  UpdateGroupActivityMutationVariables
>;

/**
 * __useUpdateGroupActivityMutation__
 *
 * To run a mutation, you first call `useUpdateGroupActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupActivityMutation, { data, loading, error }] = useUpdateGroupActivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateGroupActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateGroupActivityMutation,
    UpdateGroupActivityMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdateGroupActivityMutation,
    UpdateGroupActivityMutationVariables
  >(UpdateGroupActivityDocument, options);
}
export type UpdateGroupActivityMutationHookResult = ReturnType<
  typeof useUpdateGroupActivityMutation
>;
export type UpdateGroupActivityMutationResult =
  Apollo.MutationResult<UpdateGroupActivityMutation>;
export type UpdateGroupActivityMutationOptions = Apollo.BaseMutationOptions<
  UpdateGroupActivityMutation,
  UpdateGroupActivityMutationVariables
>;
export const UpdateGroupCommentDocument = gql`
  mutation updateGroupComment($id: ID!, $attributes: CommentInputType!) {
    updateGroupComment(input: {id: $id, attributes: $attributes}) {
      comment {
        id
        message
        isEdit
        isRemove
      }
    }
  }
`;
export type UpdateGroupCommentMutationFn = Apollo.MutationFunction<
  UpdateGroupCommentMutation,
  UpdateGroupCommentMutationVariables
>;

/**
 * __useUpdateGroupCommentMutation__
 *
 * To run a mutation, you first call `useUpdateGroupCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupCommentMutation, { data, loading, error }] = useUpdateGroupCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateGroupCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateGroupCommentMutation,
    UpdateGroupCommentMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdateGroupCommentMutation,
    UpdateGroupCommentMutationVariables
  >(UpdateGroupCommentDocument, options);
}
export type UpdateGroupCommentMutationHookResult = ReturnType<
  typeof useUpdateGroupCommentMutation
>;
export type UpdateGroupCommentMutationResult =
  Apollo.MutationResult<UpdateGroupCommentMutation>;
export type UpdateGroupCommentMutationOptions = Apollo.BaseMutationOptions<
  UpdateGroupCommentMutation,
  UpdateGroupCommentMutationVariables
>;
export const UpdateGroupUserDocument = gql`
  mutation updateGroupUser($id: ID!, $groupUser: GroupUserInputType!) {
    updateGroupUser(input: {id: $id, groupUser: $groupUser}) {
      group {
        id
        groupAdmins {
          id
          user {
            id
            email
            fullName
          }
        }
        groupMembers {
          id
          user {
            id
            email
            fullName
          }
        }
      }
    }
  }
`;
export type UpdateGroupUserMutationFn = Apollo.MutationFunction<
  UpdateGroupUserMutation,
  UpdateGroupUserMutationVariables
>;

/**
 * __useUpdateGroupUserMutation__
 *
 * To run a mutation, you first call `useUpdateGroupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupUserMutation, { data, loading, error }] = useUpdateGroupUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      groupUser: // value for 'groupUser'
 *   },
 * });
 */
export function useUpdateGroupUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateGroupUserMutation,
    UpdateGroupUserMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdateGroupUserMutation,
    UpdateGroupUserMutationVariables
  >(UpdateGroupUserDocument, options);
}
export type UpdateGroupUserMutationHookResult = ReturnType<
  typeof useUpdateGroupUserMutation
>;
export type UpdateGroupUserMutationResult =
  Apollo.MutationResult<UpdateGroupUserMutation>;
export type UpdateGroupUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateGroupUserMutation,
  UpdateGroupUserMutationVariables
>;
export const CreateNotificationDocument = gql`
  mutation createNotification($attributes: NotificationAttributes!) {
    createNotification(input: {attributes: $attributes}) {
      notification {
        ...notificationFragment
      }
    }
  }
  ${NotificationFragmentFragmentDoc}
`;
export type CreateNotificationMutationFn = Apollo.MutationFunction<
  CreateNotificationMutation,
  CreateNotificationMutationVariables
>;

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNotificationMutation,
    CreateNotificationMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreateNotificationMutation,
    CreateNotificationMutationVariables
  >(CreateNotificationDocument, options);
}
export type CreateNotificationMutationHookResult = ReturnType<
  typeof useCreateNotificationMutation
>;
export type CreateNotificationMutationResult =
  Apollo.MutationResult<CreateNotificationMutation>;
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<
  CreateNotificationMutation,
  CreateNotificationMutationVariables
>;
export const UpdateNotificationDocument = gql`
  mutation updateNotification($id: ID!, $attributes: NotificationAttributes!) {
    updateNotification(input: {id: $id, attributes: $attributes}) {
      notification {
        ...notificationFragment
      }
    }
  }
  ${NotificationFragmentFragmentDoc}
`;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<
  UpdateNotificationMutation,
  UpdateNotificationMutationVariables
>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNotificationMutation,
    UpdateNotificationMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdateNotificationMutation,
    UpdateNotificationMutationVariables
  >(UpdateNotificationDocument, options);
}
export type UpdateNotificationMutationHookResult = ReturnType<
  typeof useUpdateNotificationMutation
>;
export type UpdateNotificationMutationResult =
  Apollo.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<
  UpdateNotificationMutation,
  UpdateNotificationMutationVariables
>;
export const CancelOrderDocument = gql`
  mutation cancelOrder($id: ID!) {
    cancelOrder(input: {id: $id}) {
      order {
        ...orderFragment
      }
      error
    }
  }
  ${OrderFragmentFragmentDoc}
`;
export type CancelOrderMutationFn = Apollo.MutationFunction<
  CancelOrderMutation,
  CancelOrderMutationVariables
>;

/**
 * __useCancelOrderMutation__
 *
 * To run a mutation, you first call `useCancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrderMutation, { data, loading, error }] = useCancelOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelOrderMutation,
    CancelOrderMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CancelOrderMutation, CancelOrderMutationVariables>(
    CancelOrderDocument,
    options,
  );
}
export type CancelOrderMutationHookResult = ReturnType<
  typeof useCancelOrderMutation
>;
export type CancelOrderMutationResult =
  Apollo.MutationResult<CancelOrderMutation>;
export type CancelOrderMutationOptions = Apollo.BaseMutationOptions<
  CancelOrderMutation,
  CancelOrderMutationVariables
>;
export const MarkOrderPaidDocument = gql`
  mutation markOrderPaid($id: ID!) {
    markOrderPaid(input: {id: $id}) {
      order {
        ...orderFragment
      }
      error
    }
  }
  ${OrderFragmentFragmentDoc}
`;
export type MarkOrderPaidMutationFn = Apollo.MutationFunction<
  MarkOrderPaidMutation,
  MarkOrderPaidMutationVariables
>;

/**
 * __useMarkOrderPaidMutation__
 *
 * To run a mutation, you first call `useMarkOrderPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOrderPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOrderPaidMutation, { data, loading, error }] = useMarkOrderPaidMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkOrderPaidMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkOrderPaidMutation,
    MarkOrderPaidMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    MarkOrderPaidMutation,
    MarkOrderPaidMutationVariables
  >(MarkOrderPaidDocument, options);
}
export type MarkOrderPaidMutationHookResult = ReturnType<
  typeof useMarkOrderPaidMutation
>;
export type MarkOrderPaidMutationResult =
  Apollo.MutationResult<MarkOrderPaidMutation>;
export type MarkOrderPaidMutationOptions = Apollo.BaseMutationOptions<
  MarkOrderPaidMutation,
  MarkOrderPaidMutationVariables
>;
export const CreatePaymentDocument = gql`
  mutation createPayment($attributes: PaymentInputType!) {
    createPayment(input: {attributes: $attributes}) {
      payment {
        ...paymentFragment
      }
      error
    }
  }
  ${PaymentFragmentFragmentDoc}
`;
export type CreatePaymentMutationFn = Apollo.MutationFunction<
  CreatePaymentMutation,
  CreatePaymentMutationVariables
>;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreatePaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePaymentMutation,
    CreatePaymentMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreatePaymentMutation,
    CreatePaymentMutationVariables
  >(CreatePaymentDocument, options);
}
export type CreatePaymentMutationHookResult = ReturnType<
  typeof useCreatePaymentMutation
>;
export type CreatePaymentMutationResult =
  Apollo.MutationResult<CreatePaymentMutation>;
export type CreatePaymentMutationOptions = Apollo.BaseMutationOptions<
  CreatePaymentMutation,
  CreatePaymentMutationVariables
>;
export const UpdatePaymentDocument = gql`
  mutation updatePayment($id: ID!, $attributes: PaymentInputType!) {
    updatePayment(input: {id: $id, attributes: $attributes}) {
      payment {
        ...paymentFragment
      }
      error
    }
  }
  ${PaymentFragmentFragmentDoc}
`;
export type UpdatePaymentMutationFn = Apollo.MutationFunction<
  UpdatePaymentMutation,
  UpdatePaymentMutationVariables
>;

/**
 * __useUpdatePaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMutation, { data, loading, error }] = useUpdatePaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePaymentMutation,
    UpdatePaymentMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdatePaymentMutation,
    UpdatePaymentMutationVariables
  >(UpdatePaymentDocument, options);
}
export type UpdatePaymentMutationHookResult = ReturnType<
  typeof useUpdatePaymentMutation
>;
export type UpdatePaymentMutationResult =
  Apollo.MutationResult<UpdatePaymentMutation>;
export type UpdatePaymentMutationOptions = Apollo.BaseMutationOptions<
  UpdatePaymentMutation,
  UpdatePaymentMutationVariables
>;
export const CreateRoomCalendarDocument = gql`
  mutation createRoomCalendar($roomCalendar: RoomCalendarInputType!) {
    createRoomCalendar(input: {roomCalendar: $roomCalendar}) {
      roomCalendar {
        ...roomCalendarFragment
        event {
          ...eventFragment
        }
      }
      error
    }
  }
  ${RoomCalendarFragmentFragmentDoc}
  ${EventFragmentFragmentDoc}
`;
export type CreateRoomCalendarMutationFn = Apollo.MutationFunction<
  CreateRoomCalendarMutation,
  CreateRoomCalendarMutationVariables
>;

/**
 * __useCreateRoomCalendarMutation__
 *
 * To run a mutation, you first call `useCreateRoomCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomCalendarMutation, { data, loading, error }] = useCreateRoomCalendarMutation({
 *   variables: {
 *      roomCalendar: // value for 'roomCalendar'
 *   },
 * });
 */
export function useCreateRoomCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRoomCalendarMutation,
    CreateRoomCalendarMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreateRoomCalendarMutation,
    CreateRoomCalendarMutationVariables
  >(CreateRoomCalendarDocument, options);
}
export type CreateRoomCalendarMutationHookResult = ReturnType<
  typeof useCreateRoomCalendarMutation
>;
export type CreateRoomCalendarMutationResult =
  Apollo.MutationResult<CreateRoomCalendarMutation>;
export type CreateRoomCalendarMutationOptions = Apollo.BaseMutationOptions<
  CreateRoomCalendarMutation,
  CreateRoomCalendarMutationVariables
>;
export const RemoveRoomCalendarDocument = gql`
  mutation removeRoomCalendar($id: ID!) {
    removeRoomCalendar(input: {id: $id}) {
      id
      error
    }
  }
`;
export type RemoveRoomCalendarMutationFn = Apollo.MutationFunction<
  RemoveRoomCalendarMutation,
  RemoveRoomCalendarMutationVariables
>;

/**
 * __useRemoveRoomCalendarMutation__
 *
 * To run a mutation, you first call `useRemoveRoomCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoomCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoomCalendarMutation, { data, loading, error }] = useRemoveRoomCalendarMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveRoomCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveRoomCalendarMutation,
    RemoveRoomCalendarMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    RemoveRoomCalendarMutation,
    RemoveRoomCalendarMutationVariables
  >(RemoveRoomCalendarDocument, options);
}
export type RemoveRoomCalendarMutationHookResult = ReturnType<
  typeof useRemoveRoomCalendarMutation
>;
export type RemoveRoomCalendarMutationResult =
  Apollo.MutationResult<RemoveRoomCalendarMutation>;
export type RemoveRoomCalendarMutationOptions = Apollo.BaseMutationOptions<
  RemoveRoomCalendarMutation,
  RemoveRoomCalendarMutationVariables
>;
export const UpdateRoomCalendarDocument = gql`
  mutation updateRoomCalendar($id: ID!, $attributes: RoomCalendarInputType!) {
    updateRoomCalendar(input: {id: $id, attributes: $attributes}) {
      roomCalendar {
        ...roomCalendarFragment
      }
    }
  }
  ${RoomCalendarFragmentFragmentDoc}
`;
export type UpdateRoomCalendarMutationFn = Apollo.MutationFunction<
  UpdateRoomCalendarMutation,
  UpdateRoomCalendarMutationVariables
>;

/**
 * __useUpdateRoomCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateRoomCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomCalendarMutation, { data, loading, error }] = useUpdateRoomCalendarMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateRoomCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRoomCalendarMutation,
    UpdateRoomCalendarMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdateRoomCalendarMutation,
    UpdateRoomCalendarMutationVariables
  >(UpdateRoomCalendarDocument, options);
}
export type UpdateRoomCalendarMutationHookResult = ReturnType<
  typeof useUpdateRoomCalendarMutation
>;
export type UpdateRoomCalendarMutationResult =
  Apollo.MutationResult<UpdateRoomCalendarMutation>;
export type UpdateRoomCalendarMutationOptions = Apollo.BaseMutationOptions<
  UpdateRoomCalendarMutation,
  UpdateRoomCalendarMutationVariables
>;
export const ActivateUserDocument = gql`
  mutation activateUser($id: ID!) {
    activateUser(input: {id: $id}) {
      user {
        ...userFragment
      }
    }
  }
  ${UserFragmentFragmentDoc}
`;
export type ActivateUserMutationFn = Apollo.MutationFunction<
  ActivateUserMutation,
  ActivateUserMutationVariables
>;

/**
 * __useActivateUserMutation__
 *
 * To run a mutation, you first call `useActivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUserMutation, { data, loading, error }] = useActivateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateUserMutation,
    ActivateUserMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ActivateUserMutation,
    ActivateUserMutationVariables
  >(ActivateUserDocument, options);
}
export type ActivateUserMutationHookResult = ReturnType<
  typeof useActivateUserMutation
>;
export type ActivateUserMutationResult =
  Apollo.MutationResult<ActivateUserMutation>;
export type ActivateUserMutationOptions = Apollo.BaseMutationOptions<
  ActivateUserMutation,
  ActivateUserMutationVariables
>;
export const DeactivateUserDocument = gql`
  mutation deactivateUser($id: ID!) {
    deactivateUser(input: {id: $id}) {
      user {
        ...userFragment
      }
    }
  }
  ${UserFragmentFragmentDoc}
`;
export type DeactivateUserMutationFn = Apollo.MutationFunction<
  DeactivateUserMutation,
  DeactivateUserMutationVariables
>;

/**
 * __useDeactivateUserMutation__
 *
 * To run a mutation, you first call `useDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserMutation, { data, loading, error }] = useDeactivateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateUserMutation,
    DeactivateUserMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    DeactivateUserMutation,
    DeactivateUserMutationVariables
  >(DeactivateUserDocument, options);
}
export type DeactivateUserMutationHookResult = ReturnType<
  typeof useDeactivateUserMutation
>;
export type DeactivateUserMutationResult =
  Apollo.MutationResult<DeactivateUserMutation>;
export type DeactivateUserMutationOptions = Apollo.BaseMutationOptions<
  DeactivateUserMutation,
  DeactivateUserMutationVariables
>;
export const UpdateAddressDocument = gql`
  mutation updateAddress($id: ID!, $attributes: AddressInputType) {
    updateAddress(input: {id: $id, attributes: $attributes}) {
      address {
        ...addressFragment
      }
    }
  }
  ${AddressFragmentFragmentDoc}
`;
export type UpdateAddressMutationFn = Apollo.MutationFunction<
  UpdateAddressMutation,
  UpdateAddressMutationVariables
>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAddressMutation,
    UpdateAddressMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdateAddressMutation,
    UpdateAddressMutationVariables
  >(UpdateAddressDocument, options);
}
export type UpdateAddressMutationHookResult = ReturnType<
  typeof useUpdateAddressMutation
>;
export type UpdateAddressMutationResult =
  Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<
  UpdateAddressMutation,
  UpdateAddressMutationVariables
>;
export const UpdatePasswordDocument = gql`
  mutation updatePassword($id: ID!, $attributes: UserInputType!) {
    updatePassword(input: {id: $id, attributes: $attributes}) {
      user {
        ...userFragment
      }
      error
    }
  }
  ${UserFragmentFragmentDoc}
`;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<
  UpdatePasswordMutation,
  UpdatePasswordMutationVariables
>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePasswordMutation,
    UpdatePasswordMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdatePasswordMutation,
    UpdatePasswordMutationVariables
  >(UpdatePasswordDocument, options);
}
export type UpdatePasswordMutationHookResult = ReturnType<
  typeof useUpdatePasswordMutation
>;
export type UpdatePasswordMutationResult =
  Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<
  UpdatePasswordMutation,
  UpdatePasswordMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation updateUser($id: ID!, $file: File, $user: UserInputType) {
    updateUser(input: {id: $id, file: $file, user: $user}) {
      user {
        ...userFragment
      }
    }
  }
  ${UserFragmentFragmentDoc}
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options,
  );
}
export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>;
export type UpdateUserMutationResult =
  Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const BankDocument = gql`
  query bank {
    bank {
      ...bankFragment
    }
  }
  ${BankFragmentFragmentDoc}
`;

/**
 * __useBankQuery__
 *
 * To run a query within a React component, call `useBankQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankQuery(
  baseOptions?: Apollo.QueryHookOptions<BankQuery, BankQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<BankQuery, BankQueryVariables>(BankDocument, options);
}
export function useBankLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BankQuery, BankQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<BankQuery, BankQueryVariables>(
    BankDocument,
    options,
  );
}
// @ts-ignore
export function useBankSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<BankQuery, BankQueryVariables>,
): Apollo.UseSuspenseQueryResult<BankQuery, BankQueryVariables>;
export function useBankSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BankQuery, BankQueryVariables>,
): Apollo.UseSuspenseQueryResult<BankQuery | undefined, BankQueryVariables>;
export function useBankSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BankQuery, BankQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<BankQuery, BankQueryVariables>(
    BankDocument,
    options,
  );
}
export type BankQueryHookResult = ReturnType<typeof useBankQuery>;
export type BankLazyQueryHookResult = ReturnType<typeof useBankLazyQuery>;
export type BankSuspenseQueryHookResult = ReturnType<
  typeof useBankSuspenseQuery
>;
export type BankQueryResult = Apollo.QueryResult<BankQuery, BankQueryVariables>;
export const CurrentOrderDocument = gql`
  query currentOrder {
    currentOrder {
      ...orderFragment
      event {
        ...eventFragment
        eventSchedules {
          ...eventScheduleFragment
        }
      }
    }
  }
  ${OrderFragmentFragmentDoc}
  ${EventFragmentFragmentDoc}
  ${EventScheduleFragmentFragmentDoc}
`;

/**
 * __useCurrentOrderQuery__
 *
 * To run a query within a React component, call `useCurrentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentOrderQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentOrderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CurrentOrderQuery,
    CurrentOrderQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CurrentOrderQuery, CurrentOrderQueryVariables>(
    CurrentOrderDocument,
    options,
  );
}
export function useCurrentOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentOrderQuery,
    CurrentOrderQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<CurrentOrderQuery, CurrentOrderQueryVariables>(
    CurrentOrderDocument,
    options,
  );
}
// @ts-ignore
export function useCurrentOrderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CurrentOrderQuery,
    CurrentOrderQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CurrentOrderQuery, CurrentOrderQueryVariables>;
export function useCurrentOrderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentOrderQuery,
        CurrentOrderQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CurrentOrderQuery | undefined,
  CurrentOrderQueryVariables
>;
export function useCurrentOrderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentOrderQuery,
        CurrentOrderQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<CurrentOrderQuery, CurrentOrderQueryVariables>(
    CurrentOrderDocument,
    options,
  );
}
export type CurrentOrderQueryHookResult = ReturnType<
  typeof useCurrentOrderQuery
>;
export type CurrentOrderLazyQueryHookResult = ReturnType<
  typeof useCurrentOrderLazyQuery
>;
export type CurrentOrderSuspenseQueryHookResult = ReturnType<
  typeof useCurrentOrderSuspenseQuery
>;
export type CurrentOrderQueryResult = Apollo.QueryResult<
  CurrentOrderQuery,
  CurrentOrderQueryVariables
>;
export const CurrentUserDocument = gql`
  query currentUser {
    currentUser {
      ...userFragment
      payjpCustomer {
        id
        card {
          id
          cardId
          customerId
          created
          name
          last4
          expMonth
          expYear
        }
      }
      address {
        ...addressFragment
        industryType {
          id
        }
      }
    }
  }
  ${UserFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CurrentUserQuery,
    CurrentUserQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
export function useCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentUserQuery,
    CurrentUserQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
// @ts-ignore
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CurrentUserQuery,
    CurrentUserQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentUserQuery,
        CurrentUserQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CurrentUserQuery | undefined,
  CurrentUserQueryVariables
>;
export function useCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentUserQuery,
        CurrentUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<
  typeof useCurrentUserLazyQuery
>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<
  typeof useCurrentUserSuspenseQuery
>;
export type CurrentUserQueryResult = Apollo.QueryResult<
  CurrentUserQuery,
  CurrentUserQueryVariables
>;
export const DoorKeyDocument = gql`
  query doorKey($token: String!) {
    doorKey(token: $token) {
      ...publicDoorKeyFragment
    }
  }
  ${PublicDoorKeyFragmentFragmentDoc}
`;

/**
 * __useDoorKeyQuery__
 *
 * To run a query within a React component, call `useDoorKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoorKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoorKeyQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDoorKeyQuery(
  baseOptions: Apollo.QueryHookOptions<DoorKeyQuery, DoorKeyQueryVariables> &
    ({variables: DoorKeyQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<DoorKeyQuery, DoorKeyQueryVariables>(
    DoorKeyDocument,
    options,
  );
}
export function useDoorKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DoorKeyQuery,
    DoorKeyQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<DoorKeyQuery, DoorKeyQueryVariables>(
    DoorKeyDocument,
    options,
  );
}
// @ts-ignore
export function useDoorKeySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DoorKeyQuery,
    DoorKeyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DoorKeyQuery, DoorKeyQueryVariables>;
export function useDoorKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DoorKeyQuery, DoorKeyQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  DoorKeyQuery | undefined,
  DoorKeyQueryVariables
>;
export function useDoorKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DoorKeyQuery, DoorKeyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<DoorKeyQuery, DoorKeyQueryVariables>(
    DoorKeyDocument,
    options,
  );
}
export type DoorKeyQueryHookResult = ReturnType<typeof useDoorKeyQuery>;
export type DoorKeyLazyQueryHookResult = ReturnType<typeof useDoorKeyLazyQuery>;
export type DoorKeySuspenseQueryHookResult = ReturnType<
  typeof useDoorKeySuspenseQuery
>;
export type DoorKeyQueryResult = Apollo.QueryResult<
  DoorKeyQuery,
  DoorKeyQueryVariables
>;
export const AdminDoorKeyDocument = gql`
  query adminDoorKey($id: ID!) {
    adminDoorKey(id: $id) {
      ...adminDoorKeyFragment
    }
  }
  ${AdminDoorKeyFragmentFragmentDoc}
`;

/**
 * __useAdminDoorKeyQuery__
 *
 * To run a query within a React component, call `useAdminDoorKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDoorKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDoorKeyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDoorKeyQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminDoorKeyQuery,
    AdminDoorKeyQueryVariables
  > &
    ({variables: AdminDoorKeyQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<AdminDoorKeyQuery, AdminDoorKeyQueryVariables>(
    AdminDoorKeyDocument,
    options,
  );
}
export function useAdminDoorKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminDoorKeyQuery,
    AdminDoorKeyQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<AdminDoorKeyQuery, AdminDoorKeyQueryVariables>(
    AdminDoorKeyDocument,
    options,
  );
}
// @ts-ignore
export function useAdminDoorKeySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminDoorKeyQuery,
    AdminDoorKeyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminDoorKeyQuery, AdminDoorKeyQueryVariables>;
export function useAdminDoorKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminDoorKeyQuery,
        AdminDoorKeyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminDoorKeyQuery | undefined,
  AdminDoorKeyQueryVariables
>;
export function useAdminDoorKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminDoorKeyQuery,
        AdminDoorKeyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<AdminDoorKeyQuery, AdminDoorKeyQueryVariables>(
    AdminDoorKeyDocument,
    options,
  );
}
export type AdminDoorKeyQueryHookResult = ReturnType<
  typeof useAdminDoorKeyQuery
>;
export type AdminDoorKeyLazyQueryHookResult = ReturnType<
  typeof useAdminDoorKeyLazyQuery
>;
export type AdminDoorKeySuspenseQueryHookResult = ReturnType<
  typeof useAdminDoorKeySuspenseQuery
>;
export type AdminDoorKeyQueryResult = Apollo.QueryResult<
  AdminDoorKeyQuery,
  AdminDoorKeyQueryVariables
>;
export const DoorKeyWebhookReceiptsDocument = gql`
  query doorKeyWebhookReceipts($results: [String!]) {
    doorKeyWebhookReceipts(results: $results) {
      id
      createdAt
      externalReservationId
      guestName
      startsAt
      endsAt
      result
      resultName
      reason
      doorKey {
        id
        keyNumber
      }
    }
  }
`;

/**
 * __useDoorKeyWebhookReceiptsQuery__
 *
 * To run a query within a React component, call `useDoorKeyWebhookReceiptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoorKeyWebhookReceiptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoorKeyWebhookReceiptsQuery({
 *   variables: {
 *      results: // value for 'results'
 *   },
 * });
 */
export function useDoorKeyWebhookReceiptsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DoorKeyWebhookReceiptsQuery,
    DoorKeyWebhookReceiptsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    DoorKeyWebhookReceiptsQuery,
    DoorKeyWebhookReceiptsQueryVariables
  >(DoorKeyWebhookReceiptsDocument, options);
}
export function useDoorKeyWebhookReceiptsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DoorKeyWebhookReceiptsQuery,
    DoorKeyWebhookReceiptsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    DoorKeyWebhookReceiptsQuery,
    DoorKeyWebhookReceiptsQueryVariables
  >(DoorKeyWebhookReceiptsDocument, options);
}
// @ts-ignore
export function useDoorKeyWebhookReceiptsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DoorKeyWebhookReceiptsQuery,
    DoorKeyWebhookReceiptsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DoorKeyWebhookReceiptsQuery,
  DoorKeyWebhookReceiptsQueryVariables
>;
export function useDoorKeyWebhookReceiptsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DoorKeyWebhookReceiptsQuery,
        DoorKeyWebhookReceiptsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DoorKeyWebhookReceiptsQuery | undefined,
  DoorKeyWebhookReceiptsQueryVariables
>;
export function useDoorKeyWebhookReceiptsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DoorKeyWebhookReceiptsQuery,
        DoorKeyWebhookReceiptsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    DoorKeyWebhookReceiptsQuery,
    DoorKeyWebhookReceiptsQueryVariables
  >(DoorKeyWebhookReceiptsDocument, options);
}
export type DoorKeyWebhookReceiptsQueryHookResult = ReturnType<
  typeof useDoorKeyWebhookReceiptsQuery
>;
export type DoorKeyWebhookReceiptsLazyQueryHookResult = ReturnType<
  typeof useDoorKeyWebhookReceiptsLazyQuery
>;
export type DoorKeyWebhookReceiptsSuspenseQueryHookResult = ReturnType<
  typeof useDoorKeyWebhookReceiptsSuspenseQuery
>;
export type DoorKeyWebhookReceiptsQueryResult = Apollo.QueryResult<
  DoorKeyWebhookReceiptsQuery,
  DoorKeyWebhookReceiptsQueryVariables
>;
export const DoorKeysDocument = gql`
  query doorKeys($page: Int!, $search: DoorKeySearch) {
    doorKeys(page: $page, search: $search) {
      doorKeys {
        ...adminDoorKeyFragment
      }
      pagination {
        ...paginationFragment
      }
    }
  }
  ${AdminDoorKeyFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useDoorKeysQuery__
 *
 * To run a query within a React component, call `useDoorKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoorKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoorKeysQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useDoorKeysQuery(
  baseOptions: Apollo.QueryHookOptions<DoorKeysQuery, DoorKeysQueryVariables> &
    ({variables: DoorKeysQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<DoorKeysQuery, DoorKeysQueryVariables>(
    DoorKeysDocument,
    options,
  );
}
export function useDoorKeysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DoorKeysQuery,
    DoorKeysQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<DoorKeysQuery, DoorKeysQueryVariables>(
    DoorKeysDocument,
    options,
  );
}
// @ts-ignore
export function useDoorKeysSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DoorKeysQuery,
    DoorKeysQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DoorKeysQuery, DoorKeysQueryVariables>;
export function useDoorKeysSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DoorKeysQuery, DoorKeysQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  DoorKeysQuery | undefined,
  DoorKeysQueryVariables
>;
export function useDoorKeysSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DoorKeysQuery, DoorKeysQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<DoorKeysQuery, DoorKeysQueryVariables>(
    DoorKeysDocument,
    options,
  );
}
export type DoorKeysQueryHookResult = ReturnType<typeof useDoorKeysQuery>;
export type DoorKeysLazyQueryHookResult = ReturnType<
  typeof useDoorKeysLazyQuery
>;
export type DoorKeysSuspenseQueryHookResult = ReturnType<
  typeof useDoorKeysSuspenseQuery
>;
export type DoorKeysQueryResult = Apollo.QueryResult<
  DoorKeysQuery,
  DoorKeysQueryVariables
>;
export const DoorLockHistoryDocument = gql`
  query doorLockHistory($target: String!) {
    doorLockHistory(target: $target) {
      at
      operation
      via
      tag
      doorKey {
        id
        guestName
      }
    }
  }
`;

/**
 * __useDoorLockHistoryQuery__
 *
 * To run a query within a React component, call `useDoorLockHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoorLockHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoorLockHistoryQuery({
 *   variables: {
 *      target: // value for 'target'
 *   },
 * });
 */
export function useDoorLockHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    DoorLockHistoryQuery,
    DoorLockHistoryQueryVariables
  > &
    (
      | {variables: DoorLockHistoryQueryVariables; skip?: boolean}
      | {skip: boolean}
    ),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<DoorLockHistoryQuery, DoorLockHistoryQueryVariables>(
    DoorLockHistoryDocument,
    options,
  );
}
export function useDoorLockHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DoorLockHistoryQuery,
    DoorLockHistoryQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    DoorLockHistoryQuery,
    DoorLockHistoryQueryVariables
  >(DoorLockHistoryDocument, options);
}
// @ts-ignore
export function useDoorLockHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DoorLockHistoryQuery,
    DoorLockHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DoorLockHistoryQuery,
  DoorLockHistoryQueryVariables
>;
export function useDoorLockHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DoorLockHistoryQuery,
        DoorLockHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DoorLockHistoryQuery | undefined,
  DoorLockHistoryQueryVariables
>;
export function useDoorLockHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DoorLockHistoryQuery,
        DoorLockHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    DoorLockHistoryQuery,
    DoorLockHistoryQueryVariables
  >(DoorLockHistoryDocument, options);
}
export type DoorLockHistoryQueryHookResult = ReturnType<
  typeof useDoorLockHistoryQuery
>;
export type DoorLockHistoryLazyQueryHookResult = ReturnType<
  typeof useDoorLockHistoryLazyQuery
>;
export type DoorLockHistorySuspenseQueryHookResult = ReturnType<
  typeof useDoorLockHistorySuspenseQuery
>;
export type DoorLockHistoryQueryResult = Apollo.QueryResult<
  DoorLockHistoryQuery,
  DoorLockHistoryQueryVariables
>;
export const DoorLocksDocument = gql`
  query doorLocks {
    doorLocks {
      target
      targetName
      batteryPercentage
      lockStatus
      fetchedAt
      lowBattery
      lowBatteryThreshold
    }
  }
`;

/**
 * __useDoorLocksQuery__
 *
 * To run a query within a React component, call `useDoorLocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoorLocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoorLocksQuery({
 *   variables: {
 *   },
 * });
 */
export function useDoorLocksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DoorLocksQuery,
    DoorLocksQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<DoorLocksQuery, DoorLocksQueryVariables>(
    DoorLocksDocument,
    options,
  );
}
export function useDoorLocksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DoorLocksQuery,
    DoorLocksQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<DoorLocksQuery, DoorLocksQueryVariables>(
    DoorLocksDocument,
    options,
  );
}
// @ts-ignore
export function useDoorLocksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DoorLocksQuery,
    DoorLocksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DoorLocksQuery, DoorLocksQueryVariables>;
export function useDoorLocksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DoorLocksQuery, DoorLocksQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  DoorLocksQuery | undefined,
  DoorLocksQueryVariables
>;
export function useDoorLocksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DoorLocksQuery, DoorLocksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<DoorLocksQuery, DoorLocksQueryVariables>(
    DoorLocksDocument,
    options,
  );
}
export type DoorLocksQueryHookResult = ReturnType<typeof useDoorLocksQuery>;
export type DoorLocksLazyQueryHookResult = ReturnType<
  typeof useDoorLocksLazyQuery
>;
export type DoorLocksSuspenseQueryHookResult = ReturnType<
  typeof useDoorLocksSuspenseQuery
>;
export type DoorLocksQueryResult = Apollo.QueryResult<
  DoorLocksQuery,
  DoorLocksQueryVariables
>;
export const EventDocument = gql`
  query event($id: ID!) {
    myEvents {
      ...eventFragment
    }
    event(id: $id) {
      ...eventFragment
      overFirstEventDate
      eventSchedules {
        ...eventScheduleFragment
      }
      acceptedOrders {
        ...orderFragment
        user {
          ...userFragment
          payjpCustomer {
            id
            userId
            customerId
          }
          address {
            id
            userId
            tel
          }
        }
      }
      user {
        ...userFragment
        payjpCustomer {
          id
          userId
          customerId
        }
        address {
          ...addressFragment
          industryType {
            id
            name
          }
        }
        bank {
          ...bankFragment
        }
      }
      roomCalendars {
        ...roomCalendarFragment
        room {
          id
          name
        }
      }
      eventOptions {
        ...eventOptionFragment
        option {
          id
          name
          optionType
          description
        }
      }
      payment {
        ...paymentFragment
        payjpCard {
          id
          cardId
          last4
          expMonth
          expYear
        }
      }
      groupId
      group {
        id
        name
        mainImageUrl
        followers {
          id
          groupId
          userId
        }
      }
      user {
        id
      }
    }
    options {
      id
      name
      optionType
      description
    }
    rooms {
      id
      name
    }
  }
  ${EventFragmentFragmentDoc}
  ${EventScheduleFragmentFragmentDoc}
  ${OrderFragmentFragmentDoc}
  ${UserFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${BankFragmentFragmentDoc}
  ${RoomCalendarFragmentFragmentDoc}
  ${EventOptionFragmentFragmentDoc}
  ${PaymentFragmentFragmentDoc}
`;

/**
 * __useEventQuery__
 *
 * To run a query within a React component, call `useEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventQuery(
  baseOptions: Apollo.QueryHookOptions<EventQuery, EventQueryVariables> &
    ({variables: EventQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<EventQuery, EventQueryVariables>(
    EventDocument,
    options,
  );
}
export function useEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EventQuery, EventQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<EventQuery, EventQueryVariables>(
    EventDocument,
    options,
  );
}
// @ts-ignore
export function useEventSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EventQuery,
    EventQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EventQuery, EventQueryVariables>;
export function useEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EventQuery, EventQueryVariables>,
): Apollo.UseSuspenseQueryResult<EventQuery | undefined, EventQueryVariables>;
export function useEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EventQuery, EventQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<EventQuery, EventQueryVariables>(
    EventDocument,
    options,
  );
}
export type EventQueryHookResult = ReturnType<typeof useEventQuery>;
export type EventLazyQueryHookResult = ReturnType<typeof useEventLazyQuery>;
export type EventSuspenseQueryHookResult = ReturnType<
  typeof useEventSuspenseQuery
>;
export type EventQueryResult = Apollo.QueryResult<
  EventQuery,
  EventQueryVariables
>;
export const EventsDocument = gql`
  query events($page: Int!, $search: EventSearch) {
    events(page: $page, search: $search) {
      events {
        ...eventFragment
        eventSchedules {
          ...eventScheduleFragment
        }
        user {
          ...userFragment
        }
        payment {
          ...paymentFragment
        }
      }
      pagination {
        ...paginationFragment
      }
    }
  }
  ${EventFragmentFragmentDoc}
  ${EventScheduleFragmentFragmentDoc}
  ${UserFragmentFragmentDoc}
  ${PaymentFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useEventsQuery(
  baseOptions: Apollo.QueryHookOptions<EventsQuery, EventsQueryVariables> &
    ({variables: EventsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<EventsQuery, EventsQueryVariables>(
    EventsDocument,
    options,
  );
}
export function useEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<EventsQuery, EventsQueryVariables>(
    EventsDocument,
    options,
  );
}
// @ts-ignore
export function useEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EventsQuery,
    EventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EventsQuery, EventsQueryVariables>;
export function useEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<EventsQuery | undefined, EventsQueryVariables>;
export function useEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<EventsQuery, EventsQueryVariables>(
    EventsDocument,
    options,
  );
}
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsSuspenseQueryHookResult = ReturnType<
  typeof useEventsSuspenseQuery
>;
export type EventsQueryResult = Apollo.QueryResult<
  EventsQuery,
  EventsQueryVariables
>;
export const MyEventsDocument = gql`
  query myEvents {
    myEvents {
      ...eventFragment
      eventSchedules {
        ...eventScheduleFragment
      }
      group {
        id
        name
      }
    }
  }
  ${EventFragmentFragmentDoc}
  ${EventScheduleFragmentFragmentDoc}
`;

/**
 * __useMyEventsQuery__
 *
 * To run a query within a React component, call `useMyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<MyEventsQuery, MyEventsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<MyEventsQuery, MyEventsQueryVariables>(
    MyEventsDocument,
    options,
  );
}
export function useMyEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyEventsQuery,
    MyEventsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<MyEventsQuery, MyEventsQueryVariables>(
    MyEventsDocument,
    options,
  );
}
// @ts-ignore
export function useMyEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyEventsQuery,
    MyEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MyEventsQuery, MyEventsQueryVariables>;
export function useMyEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyEventsQuery, MyEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  MyEventsQuery | undefined,
  MyEventsQueryVariables
>;
export function useMyEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyEventsQuery, MyEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<MyEventsQuery, MyEventsQueryVariables>(
    MyEventsDocument,
    options,
  );
}
export type MyEventsQueryHookResult = ReturnType<typeof useMyEventsQuery>;
export type MyEventsLazyQueryHookResult = ReturnType<
  typeof useMyEventsLazyQuery
>;
export type MyEventsSuspenseQueryHookResult = ReturnType<
  typeof useMyEventsSuspenseQuery
>;
export type MyEventsQueryResult = Apollo.QueryResult<
  MyEventsQuery,
  MyEventsQueryVariables
>;
export const GroupDocument = gql`
  query group($id: ID!) {
    myGroups {
      ...groupFragment
    }
    group(id: $id) {
      ...groupFragment
      users {
        id
        email
        fullName
      }
      requests {
        id
        groupId
        userId
        status
        createdAtText
        user {
          ...userFragment
        }
      }
      groupAdmins {
        id
        user {
          id
          email
          fullName
        }
      }
      groupMembers {
        id
        user {
          id
          email
          fullName
        }
      }
      groupUsers {
        id
        role
        user {
          id
          email
          fullName
        }
      }
      myRequestStatus
      followers {
        id
        userId
        groupId
        user {
          id
          email
          fullName
        }
      }
      activities {
        ...groupActivityFragment
        comments {
          ...groupCommentFragment
          user {
            id
            fullName
            avatar
          }
        }
      }
    }
  }
  ${GroupFragmentFragmentDoc}
  ${UserFragmentFragmentDoc}
  ${GroupActivityFragmentFragmentDoc}
  ${GroupCommentFragmentFragmentDoc}
`;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupQuery(
  baseOptions: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables> &
    ({variables: GroupQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options,
  );
}
export function useGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options,
  );
}
// @ts-ignore
export function useGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GroupQuery,
    GroupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GroupQuery, GroupQueryVariables>;
export function useGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>,
): Apollo.UseSuspenseQueryResult<GroupQuery | undefined, GroupQueryVariables>;
export function useGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options,
  );
}
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupSuspenseQueryHookResult = ReturnType<
  typeof useGroupSuspenseQuery
>;
export type GroupQueryResult = Apollo.QueryResult<
  GroupQuery,
  GroupQueryVariables
>;
export const GroupDetailDocument = gql`
  query groupDetail($id: ID!) {
    group(id: $id) {
      ...groupFragment
      isMember
      isFollower
      myRequestStatus
      groupUsers {
        id
        role
        user {
          id
          fullName
        }
      }
      followers {
        id
        user {
          id
          fullName
        }
      }
    }
  }
  ${GroupFragmentFragmentDoc}
`;

/**
 * __useGroupDetailQuery__
 *
 * To run a query within a React component, call `useGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    GroupDetailQuery,
    GroupDetailQueryVariables
  > &
    ({variables: GroupDetailQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<GroupDetailQuery, GroupDetailQueryVariables>(
    GroupDetailDocument,
    options,
  );
}
export function useGroupDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupDetailQuery,
    GroupDetailQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<GroupDetailQuery, GroupDetailQueryVariables>(
    GroupDetailDocument,
    options,
  );
}
// @ts-ignore
export function useGroupDetailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GroupDetailQuery,
    GroupDetailQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GroupDetailQuery, GroupDetailQueryVariables>;
export function useGroupDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupDetailQuery,
        GroupDetailQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GroupDetailQuery | undefined,
  GroupDetailQueryVariables
>;
export function useGroupDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupDetailQuery,
        GroupDetailQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<GroupDetailQuery, GroupDetailQueryVariables>(
    GroupDetailDocument,
    options,
  );
}
export type GroupDetailQueryHookResult = ReturnType<typeof useGroupDetailQuery>;
export type GroupDetailLazyQueryHookResult = ReturnType<
  typeof useGroupDetailLazyQuery
>;
export type GroupDetailSuspenseQueryHookResult = ReturnType<
  typeof useGroupDetailSuspenseQuery
>;
export type GroupDetailQueryResult = Apollo.QueryResult<
  GroupDetailQuery,
  GroupDetailQueryVariables
>;
export const GroupFeatureEventsDocument = gql`
  query groupFeatureEvents($id: ID!) {
    groupFeatureEvents(id: $id) {
      id
      title
      mainImage
      mainImageUrl
      eventStatus
      eventStatusText
      eventDateText
      eventDateWday
      startTimeText
      location
      locationType
      locationTypeText
      organizer
    }
  }
`;

/**
 * __useGroupFeatureEventsQuery__
 *
 * To run a query within a React component, call `useGroupFeatureEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupFeatureEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupFeatureEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupFeatureEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GroupFeatureEventsQuery,
    GroupFeatureEventsQueryVariables
  > &
    (
      | {variables: GroupFeatureEventsQueryVariables; skip?: boolean}
      | {skip: boolean}
    ),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    GroupFeatureEventsQuery,
    GroupFeatureEventsQueryVariables
  >(GroupFeatureEventsDocument, options);
}
export function useGroupFeatureEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupFeatureEventsQuery,
    GroupFeatureEventsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    GroupFeatureEventsQuery,
    GroupFeatureEventsQueryVariables
  >(GroupFeatureEventsDocument, options);
}
// @ts-ignore
export function useGroupFeatureEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GroupFeatureEventsQuery,
    GroupFeatureEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GroupFeatureEventsQuery,
  GroupFeatureEventsQueryVariables
>;
export function useGroupFeatureEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupFeatureEventsQuery,
        GroupFeatureEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GroupFeatureEventsQuery | undefined,
  GroupFeatureEventsQueryVariables
>;
export function useGroupFeatureEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupFeatureEventsQuery,
        GroupFeatureEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    GroupFeatureEventsQuery,
    GroupFeatureEventsQueryVariables
  >(GroupFeatureEventsDocument, options);
}
export type GroupFeatureEventsQueryHookResult = ReturnType<
  typeof useGroupFeatureEventsQuery
>;
export type GroupFeatureEventsLazyQueryHookResult = ReturnType<
  typeof useGroupFeatureEventsLazyQuery
>;
export type GroupFeatureEventsSuspenseQueryHookResult = ReturnType<
  typeof useGroupFeatureEventsSuspenseQuery
>;
export type GroupFeatureEventsQueryResult = Apollo.QueryResult<
  GroupFeatureEventsQuery,
  GroupFeatureEventsQueryVariables
>;
export const GroupPastEventsDocument = gql`
  query groupPastEvents($id: ID!) {
    groupPastEvents(id: $id) {
      id
      title
      mainImage
      mainImageUrl
      eventStatus
      eventStatusText
      eventDateText
      eventDateWday
      startTimeText
      lastEventDateText
      lastEventDateWday
      lastStartTimeText
      location
      locationType
      locationTypeText
      organizer
    }
  }
`;

/**
 * __useGroupPastEventsQuery__
 *
 * To run a query within a React component, call `useGroupPastEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPastEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPastEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupPastEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GroupPastEventsQuery,
    GroupPastEventsQueryVariables
  > &
    (
      | {variables: GroupPastEventsQueryVariables; skip?: boolean}
      | {skip: boolean}
    ),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<GroupPastEventsQuery, GroupPastEventsQueryVariables>(
    GroupPastEventsDocument,
    options,
  );
}
export function useGroupPastEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupPastEventsQuery,
    GroupPastEventsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    GroupPastEventsQuery,
    GroupPastEventsQueryVariables
  >(GroupPastEventsDocument, options);
}
// @ts-ignore
export function useGroupPastEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GroupPastEventsQuery,
    GroupPastEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GroupPastEventsQuery,
  GroupPastEventsQueryVariables
>;
export function useGroupPastEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupPastEventsQuery,
        GroupPastEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GroupPastEventsQuery | undefined,
  GroupPastEventsQueryVariables
>;
export function useGroupPastEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupPastEventsQuery,
        GroupPastEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    GroupPastEventsQuery,
    GroupPastEventsQueryVariables
  >(GroupPastEventsDocument, options);
}
export type GroupPastEventsQueryHookResult = ReturnType<
  typeof useGroupPastEventsQuery
>;
export type GroupPastEventsLazyQueryHookResult = ReturnType<
  typeof useGroupPastEventsLazyQuery
>;
export type GroupPastEventsSuspenseQueryHookResult = ReturnType<
  typeof useGroupPastEventsSuspenseQuery
>;
export type GroupPastEventsQueryResult = Apollo.QueryResult<
  GroupPastEventsQuery,
  GroupPastEventsQueryVariables
>;
export const GroupsDocument = gql`
  query groups($page: Int, $perPage: Int) {
    groups(page: $page, perPage: $perPage) {
      groups {
        ...groupFragment
        groupAdmins {
          id
          user {
            id
            email
            fullName
          }
        }
      }
      pagination {
        ...paginationFragment
      }
    }
  }
  ${GroupFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(
    GroupsDocument,
    options,
  );
}
export function useGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(
    GroupsDocument,
    options,
  );
}
// @ts-ignore
export function useGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GroupsQuery,
    GroupsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GroupsQuery, GroupsQueryVariables>;
export function useGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GroupsQuery | undefined, GroupsQueryVariables>;
export function useGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<GroupsQuery, GroupsQueryVariables>(
    GroupsDocument,
    options,
  );
}
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsSuspenseQueryHookResult = ReturnType<
  typeof useGroupsSuspenseQuery
>;
export type GroupsQueryResult = Apollo.QueryResult<
  GroupsQuery,
  GroupsQueryVariables
>;
export const MyFollowsDocument = gql`
  query myFollows {
    myFollows {
      id
      isAdmin
      name
      mainImage
      mainImageUrl
      groupAdminCount
      groupMemberCount
      groupFollowerCount
    }
  }
`;

/**
 * __useMyFollowsQuery__
 *
 * To run a query within a React component, call `useMyFollowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFollowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFollowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyFollowsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyFollowsQuery,
    MyFollowsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<MyFollowsQuery, MyFollowsQueryVariables>(
    MyFollowsDocument,
    options,
  );
}
export function useMyFollowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyFollowsQuery,
    MyFollowsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<MyFollowsQuery, MyFollowsQueryVariables>(
    MyFollowsDocument,
    options,
  );
}
// @ts-ignore
export function useMyFollowsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyFollowsQuery,
    MyFollowsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MyFollowsQuery, MyFollowsQueryVariables>;
export function useMyFollowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyFollowsQuery, MyFollowsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  MyFollowsQuery | undefined,
  MyFollowsQueryVariables
>;
export function useMyFollowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyFollowsQuery, MyFollowsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<MyFollowsQuery, MyFollowsQueryVariables>(
    MyFollowsDocument,
    options,
  );
}
export type MyFollowsQueryHookResult = ReturnType<typeof useMyFollowsQuery>;
export type MyFollowsLazyQueryHookResult = ReturnType<
  typeof useMyFollowsLazyQuery
>;
export type MyFollowsSuspenseQueryHookResult = ReturnType<
  typeof useMyFollowsSuspenseQuery
>;
export type MyFollowsQueryResult = Apollo.QueryResult<
  MyFollowsQuery,
  MyFollowsQueryVariables
>;
export const MyGroupsDocument = gql`
  query myGroups {
    myGroups {
      ...groupFragment
      users {
        id
        email
        fullName
      }
      groupAdmins {
        id
      }
      groupMembers {
        id
      }
      followers {
        id
      }
    }
  }
  ${GroupFragmentFragmentDoc}
`;

/**
 * __useMyGroupsQuery__
 *
 * To run a query within a React component, call `useMyGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<MyGroupsQuery, MyGroupsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<MyGroupsQuery, MyGroupsQueryVariables>(
    MyGroupsDocument,
    options,
  );
}
export function useMyGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyGroupsQuery,
    MyGroupsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<MyGroupsQuery, MyGroupsQueryVariables>(
    MyGroupsDocument,
    options,
  );
}
// @ts-ignore
export function useMyGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyGroupsQuery,
    MyGroupsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MyGroupsQuery, MyGroupsQueryVariables>;
export function useMyGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyGroupsQuery, MyGroupsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  MyGroupsQuery | undefined,
  MyGroupsQueryVariables
>;
export function useMyGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyGroupsQuery, MyGroupsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<MyGroupsQuery, MyGroupsQueryVariables>(
    MyGroupsDocument,
    options,
  );
}
export type MyGroupsQueryHookResult = ReturnType<typeof useMyGroupsQuery>;
export type MyGroupsLazyQueryHookResult = ReturnType<
  typeof useMyGroupsLazyQuery
>;
export type MyGroupsSuspenseQueryHookResult = ReturnType<
  typeof useMyGroupsSuspenseQuery
>;
export type MyGroupsQueryResult = Apollo.QueryResult<
  MyGroupsQuery,
  MyGroupsQueryVariables
>;
export const IndustryTypesDocument = gql`
  query industryTypes {
    industryTypes {
      id
      name
    }
  }
`;

/**
 * __useIndustryTypesQuery__
 *
 * To run a query within a React component, call `useIndustryTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndustryTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndustryTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIndustryTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IndustryTypesQuery,
    IndustryTypesQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<IndustryTypesQuery, IndustryTypesQueryVariables>(
    IndustryTypesDocument,
    options,
  );
}
export function useIndustryTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IndustryTypesQuery,
    IndustryTypesQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<IndustryTypesQuery, IndustryTypesQueryVariables>(
    IndustryTypesDocument,
    options,
  );
}
// @ts-ignore
export function useIndustryTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IndustryTypesQuery,
    IndustryTypesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IndustryTypesQuery,
  IndustryTypesQueryVariables
>;
export function useIndustryTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndustryTypesQuery,
        IndustryTypesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IndustryTypesQuery | undefined,
  IndustryTypesQueryVariables
>;
export function useIndustryTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndustryTypesQuery,
        IndustryTypesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    IndustryTypesQuery,
    IndustryTypesQueryVariables
  >(IndustryTypesDocument, options);
}
export type IndustryTypesQueryHookResult = ReturnType<
  typeof useIndustryTypesQuery
>;
export type IndustryTypesLazyQueryHookResult = ReturnType<
  typeof useIndustryTypesLazyQuery
>;
export type IndustryTypesSuspenseQueryHookResult = ReturnType<
  typeof useIndustryTypesSuspenseQuery
>;
export type IndustryTypesQueryResult = Apollo.QueryResult<
  IndustryTypesQuery,
  IndustryTypesQueryVariables
>;
export const NotificationsDocument = gql`
  query notifications($page: Int, $perPage: Int) {
    notifications(page: $page, perPage: $perPage) {
      notifications {
        ...notificationFragment
      }
      pagination {
        ...paginationFragment
      }
    }
  }
  ${NotificationFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotificationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NotificationsQuery,
    NotificationsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(
    NotificationsDocument,
    options,
  );
}
export function useNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotificationsQuery,
    NotificationsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(
    NotificationsDocument,
    options,
  );
}
// @ts-ignore
export function useNotificationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NotificationsQuery,
    NotificationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  NotificationsQuery,
  NotificationsQueryVariables
>;
export function useNotificationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NotificationsQuery,
        NotificationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  NotificationsQuery | undefined,
  NotificationsQueryVariables
>;
export function useNotificationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NotificationsQuery,
        NotificationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    NotificationsQuery,
    NotificationsQueryVariables
  >(NotificationsDocument, options);
}
export type NotificationsQueryHookResult = ReturnType<
  typeof useNotificationsQuery
>;
export type NotificationsLazyQueryHookResult = ReturnType<
  typeof useNotificationsLazyQuery
>;
export type NotificationsSuspenseQueryHookResult = ReturnType<
  typeof useNotificationsSuspenseQuery
>;
export type NotificationsQueryResult = Apollo.QueryResult<
  NotificationsQuery,
  NotificationsQueryVariables
>;
export const OptionsDocument = gql`
  query options($search: OptionSearch) {
    options(search: $search) {
      ...optionFragment
    }
  }
  ${OptionFragmentFragmentDoc}
`;

/**
 * __useOptionsQuery__
 *
 * To run a query within a React component, call `useOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<OptionsQuery, OptionsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<OptionsQuery, OptionsQueryVariables>(
    OptionsDocument,
    options,
  );
}
export function useOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OptionsQuery,
    OptionsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<OptionsQuery, OptionsQueryVariables>(
    OptionsDocument,
    options,
  );
}
// @ts-ignore
export function useOptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OptionsQuery,
    OptionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<OptionsQuery, OptionsQueryVariables>;
export function useOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OptionsQuery, OptionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  OptionsQuery | undefined,
  OptionsQueryVariables
>;
export function useOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OptionsQuery, OptionsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<OptionsQuery, OptionsQueryVariables>(
    OptionsDocument,
    options,
  );
}
export type OptionsQueryHookResult = ReturnType<typeof useOptionsQuery>;
export type OptionsLazyQueryHookResult = ReturnType<typeof useOptionsLazyQuery>;
export type OptionsSuspenseQueryHookResult = ReturnType<
  typeof useOptionsSuspenseQuery
>;
export type OptionsQueryResult = Apollo.QueryResult<
  OptionsQuery,
  OptionsQueryVariables
>;
export const MyEntryOrdersDocument = gql`
  query myEntryOrders {
    myEntryOrders {
      ...orderFragment
      event {
        ...eventFragment
        eventSchedules {
          ...eventScheduleFragment
        }
      }
    }
  }
  ${OrderFragmentFragmentDoc}
  ${EventFragmentFragmentDoc}
  ${EventScheduleFragmentFragmentDoc}
`;

/**
 * __useMyEntryOrdersQuery__
 *
 * To run a query within a React component, call `useMyEntryOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEntryOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEntryOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEntryOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyEntryOrdersQuery,
    MyEntryOrdersQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<MyEntryOrdersQuery, MyEntryOrdersQueryVariables>(
    MyEntryOrdersDocument,
    options,
  );
}
export function useMyEntryOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyEntryOrdersQuery,
    MyEntryOrdersQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<MyEntryOrdersQuery, MyEntryOrdersQueryVariables>(
    MyEntryOrdersDocument,
    options,
  );
}
// @ts-ignore
export function useMyEntryOrdersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyEntryOrdersQuery,
    MyEntryOrdersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MyEntryOrdersQuery,
  MyEntryOrdersQueryVariables
>;
export function useMyEntryOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyEntryOrdersQuery,
        MyEntryOrdersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MyEntryOrdersQuery | undefined,
  MyEntryOrdersQueryVariables
>;
export function useMyEntryOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyEntryOrdersQuery,
        MyEntryOrdersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    MyEntryOrdersQuery,
    MyEntryOrdersQueryVariables
  >(MyEntryOrdersDocument, options);
}
export type MyEntryOrdersQueryHookResult = ReturnType<
  typeof useMyEntryOrdersQuery
>;
export type MyEntryOrdersLazyQueryHookResult = ReturnType<
  typeof useMyEntryOrdersLazyQuery
>;
export type MyEntryOrdersSuspenseQueryHookResult = ReturnType<
  typeof useMyEntryOrdersSuspenseQuery
>;
export type MyEntryOrdersQueryResult = Apollo.QueryResult<
  MyEntryOrdersQuery,
  MyEntryOrdersQueryVariables
>;
export const PublicEventDocument = gql`
  query publicEvent($id: ID!) {
    publicEvent(id: $id) {
      id
      title
      organizer
      description
      mainImageUrl
      eventStatus
      isFree
      ticketAmount
      ticketPaymentMethod
      ticketPaymentMethodText
      dueDate
      dueDateText
      dueDateTextFull
      dueTimeText
      cancelDate
      cancelDateText
      cancelDateTextFull
      cancelTimeText
      location
      locationType
      address
      informationEmail
      informationTel
      canOrder
      eventSchedules {
        id
        eventDateText
        eventDateWday
        startTimeText
        endTimeText
      }
      group {
        id
        name
        mainImageUrl
        groupFollowerCount
        isFollower
      }
    }
  }
`;

/**
 * __usePublicEventQuery__
 *
 * To run a query within a React component, call `usePublicEventQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicEventQuery(
  baseOptions: Apollo.QueryHookOptions<
    PublicEventQuery,
    PublicEventQueryVariables
  > &
    ({variables: PublicEventQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PublicEventQuery, PublicEventQueryVariables>(
    PublicEventDocument,
    options,
  );
}
export function usePublicEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublicEventQuery,
    PublicEventQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PublicEventQuery, PublicEventQueryVariables>(
    PublicEventDocument,
    options,
  );
}
// @ts-ignore
export function usePublicEventSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PublicEventQuery,
    PublicEventQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PublicEventQuery, PublicEventQueryVariables>;
export function usePublicEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PublicEventQuery,
        PublicEventQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PublicEventQuery | undefined,
  PublicEventQueryVariables
>;
export function usePublicEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PublicEventQuery,
        PublicEventQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<PublicEventQuery, PublicEventQueryVariables>(
    PublicEventDocument,
    options,
  );
}
export type PublicEventQueryHookResult = ReturnType<typeof usePublicEventQuery>;
export type PublicEventLazyQueryHookResult = ReturnType<
  typeof usePublicEventLazyQuery
>;
export type PublicEventSuspenseQueryHookResult = ReturnType<
  typeof usePublicEventSuspenseQuery
>;
export type PublicEventQueryResult = Apollo.QueryResult<
  PublicEventQuery,
  PublicEventQueryVariables
>;
export const PublicEventsDocument = gql`
  query publicEvents {
    publicEvents {
      id
      title
      organizer
      mainImageUrl
      eventDateText
      eventDateWday
      startTimeText
      group {
        id
        name
      }
    }
  }
`;

/**
 * __usePublicEventsQuery__
 *
 * To run a query within a React component, call `usePublicEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PublicEventsQuery,
    PublicEventsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PublicEventsQuery, PublicEventsQueryVariables>(
    PublicEventsDocument,
    options,
  );
}
export function usePublicEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublicEventsQuery,
    PublicEventsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PublicEventsQuery, PublicEventsQueryVariables>(
    PublicEventsDocument,
    options,
  );
}
// @ts-ignore
export function usePublicEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PublicEventsQuery,
    PublicEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PublicEventsQuery, PublicEventsQueryVariables>;
export function usePublicEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PublicEventsQuery,
        PublicEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PublicEventsQuery | undefined,
  PublicEventsQueryVariables
>;
export function usePublicEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PublicEventsQuery,
        PublicEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<PublicEventsQuery, PublicEventsQueryVariables>(
    PublicEventsDocument,
    options,
  );
}
export type PublicEventsQueryHookResult = ReturnType<
  typeof usePublicEventsQuery
>;
export type PublicEventsLazyQueryHookResult = ReturnType<
  typeof usePublicEventsLazyQuery
>;
export type PublicEventsSuspenseQueryHookResult = ReturnType<
  typeof usePublicEventsSuspenseQuery
>;
export type PublicEventsQueryResult = Apollo.QueryResult<
  PublicEventsQuery,
  PublicEventsQueryVariables
>;
export const RoomCalendarsDocument = gql`
  query roomCalendars($search: RoomCalendarSearch!) {
    roomCalendars(search: $search) {
      ...roomCalendarFragment
      event {
        ...eventFragment
      }
    }
    rooms {
      id
      closedFrom
    }
  }
  ${RoomCalendarFragmentFragmentDoc}
  ${EventFragmentFragmentDoc}
`;

/**
 * __useRoomCalendarsQuery__
 *
 * To run a query within a React component, call `useRoomCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomCalendarsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useRoomCalendarsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RoomCalendarsQuery,
    RoomCalendarsQueryVariables
  > &
    (
      | {variables: RoomCalendarsQueryVariables; skip?: boolean}
      | {skip: boolean}
    ),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<RoomCalendarsQuery, RoomCalendarsQueryVariables>(
    RoomCalendarsDocument,
    options,
  );
}
export function useRoomCalendarsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RoomCalendarsQuery,
    RoomCalendarsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<RoomCalendarsQuery, RoomCalendarsQueryVariables>(
    RoomCalendarsDocument,
    options,
  );
}
// @ts-ignore
export function useRoomCalendarsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RoomCalendarsQuery,
    RoomCalendarsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RoomCalendarsQuery,
  RoomCalendarsQueryVariables
>;
export function useRoomCalendarsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RoomCalendarsQuery,
        RoomCalendarsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RoomCalendarsQuery | undefined,
  RoomCalendarsQueryVariables
>;
export function useRoomCalendarsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RoomCalendarsQuery,
        RoomCalendarsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    RoomCalendarsQuery,
    RoomCalendarsQueryVariables
  >(RoomCalendarsDocument, options);
}
export type RoomCalendarsQueryHookResult = ReturnType<
  typeof useRoomCalendarsQuery
>;
export type RoomCalendarsLazyQueryHookResult = ReturnType<
  typeof useRoomCalendarsLazyQuery
>;
export type RoomCalendarsSuspenseQueryHookResult = ReturnType<
  typeof useRoomCalendarsSuspenseQuery
>;
export type RoomCalendarsQueryResult = Apollo.QueryResult<
  RoomCalendarsQuery,
  RoomCalendarsQueryVariables
>;
export const AllUsersDocument = gql`
  query allUsers {
    allUsers {
      ...userFragment
      address {
        ...addressFragment
        industryType {
          ...industryTypeFragment
        }
      }
    }
  }
  ${UserFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${IndustryTypeFragmentFragmentDoc}
`;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<AllUsersQuery, AllUsersQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<AllUsersQuery, AllUsersQueryVariables>(
    AllUsersDocument,
    options,
  );
}
export function useAllUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllUsersQuery,
    AllUsersQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(
    AllUsersDocument,
    options,
  );
}
// @ts-ignore
export function useAllUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AllUsersQuery,
    AllUsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AllUsersQuery, AllUsersQueryVariables>;
export function useAllUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AllUsersQuery | undefined,
  AllUsersQueryVariables
>;
export function useAllUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<AllUsersQuery, AllUsersQueryVariables>(
    AllUsersDocument,
    options,
  );
}
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<
  typeof useAllUsersLazyQuery
>;
export type AllUsersSuspenseQueryHookResult = ReturnType<
  typeof useAllUsersSuspenseQuery
>;
export type AllUsersQueryResult = Apollo.QueryResult<
  AllUsersQuery,
  AllUsersQueryVariables
>;
